"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vehiclesCatalogueData = void 0;
/**
 * Includes three vehicles extracted from `vehiclesCatalogueQuery`:
 * - Mercedes-Benz EQC400 AMG Edition
 * - Peugeot e208 Allure
 * - Kia e-Soul Classic 39,2 kW
 */
exports.vehiclesCatalogueData = {
    data: {
        salesPackage0: {
            id: '608fe2e2330a3f000a8b3a92',
            name: 'EQC400 AMG Edition Plus',
            defaultVariant: {
                sku: 'EQC400 4M NO7',
                priceVariants: [
                    {
                        identifier: 'default',
                        price: 715200,
                    },
                ],
                images: [
                    {
                        url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/eqc-amg-e-exterior.png',
                        key: 'bos-no-ecom-2/21/4/26/60/eqc-amg-e-exterior.png',
                        variants: [
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@100/eqc-amg-e-exterior.avif',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/60/@100/eqc-amg-e-exterior.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@100/eqc-amg-e-exterior.webp',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/60/@100/eqc-amg-e-exterior.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@100/eqc-amg-e-exterior.png',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/60/@100/eqc-amg-e-exterior.png',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@200/eqc-amg-e-exterior.avif',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/60/@200/eqc-amg-e-exterior.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@200/eqc-amg-e-exterior.webp',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/60/@200/eqc-amg-e-exterior.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@200/eqc-amg-e-exterior.png',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/60/@200/eqc-amg-e-exterior.png',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@500/eqc-amg-e-exterior.avif',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/60/@500/eqc-amg-e-exterior.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@500/eqc-amg-e-exterior.webp',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/60/@500/eqc-amg-e-exterior.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@500/eqc-amg-e-exterior.png',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/60/@500/eqc-amg-e-exterior.png',
                            },
                        ],
                    },
                    {
                        url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/eqc-amg-e-exterior2.png',
                        key: 'bos-no-ecom-2/21/4/26/60/eqc-amg-e-exterior2.png',
                        variants: [
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@100/eqc-amg-e-exterior2.avif',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/60/@100/eqc-amg-e-exterior2.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@100/eqc-amg-e-exterior2.webp',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/60/@100/eqc-amg-e-exterior2.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@100/eqc-amg-e-exterior2.png',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/60/@100/eqc-amg-e-exterior2.png',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@200/eqc-amg-e-exterior2.avif',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/60/@200/eqc-amg-e-exterior2.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@200/eqc-amg-e-exterior2.webp',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/60/@200/eqc-amg-e-exterior2.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@200/eqc-amg-e-exterior2.png',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/60/@200/eqc-amg-e-exterior2.png',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@500/eqc-amg-e-exterior2.avif',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/60/@500/eqc-amg-e-exterior2.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@500/eqc-amg-e-exterior2.webp',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/60/@500/eqc-amg-e-exterior2.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@500/eqc-amg-e-exterior2.png',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/60/@500/eqc-amg-e-exterior2.png',
                            },
                        ],
                    },
                    {
                        url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/eqc-amg-e.png',
                        key: 'bos-no-ecom-2/21/4/26/60/eqc-amg-e.png',
                        variants: [
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@100/eqc-amg-e.avif',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/60/@100/eqc-amg-e.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@100/eqc-amg-e.webp',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/60/@100/eqc-amg-e.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@100/eqc-amg-e.png',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/60/@100/eqc-amg-e.png',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@200/eqc-amg-e.avif',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/60/@200/eqc-amg-e.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@200/eqc-amg-e.webp',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/60/@200/eqc-amg-e.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@200/eqc-amg-e.png',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/60/@200/eqc-amg-e.png',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@500/eqc-amg-e.avif',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/60/@500/eqc-amg-e.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@500/eqc-amg-e.webp',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/60/@500/eqc-amg-e.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@500/eqc-amg-e.png',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/60/@500/eqc-amg-e.png',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@768/eqc-amg-e.avif',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/60/@768/eqc-amg-e.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@768/eqc-amg-e.webp',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/60/@768/eqc-amg-e.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@768/eqc-amg-e.png',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/60/@768/eqc-amg-e.png',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@1024/eqc-amg-e.avif',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/60/@1024/eqc-amg-e.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@1024/eqc-amg-e.webp',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/60/@1024/eqc-amg-e.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@1024/eqc-amg-e.png',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/60/@1024/eqc-amg-e.png',
                            },
                        ],
                    },
                    {
                        url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/skjermbilde-2020-11-16-120315.png',
                        key: 'bos-no-ecom-2/21/4/26/60/skjermbilde-2020-11-16-120315.png',
                        variants: [
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@100/skjermbilde-2020-11-16-120315.avif',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/60/@100/skjermbilde-2020-11-16-120315.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@100/skjermbilde-2020-11-16-120315.webp',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/60/@100/skjermbilde-2020-11-16-120315.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@100/skjermbilde-2020-11-16-120315.png',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/60/@100/skjermbilde-2020-11-16-120315.png',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@200/skjermbilde-2020-11-16-120315.avif',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/60/@200/skjermbilde-2020-11-16-120315.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@200/skjermbilde-2020-11-16-120315.webp',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/60/@200/skjermbilde-2020-11-16-120315.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@200/skjermbilde-2020-11-16-120315.png',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/60/@200/skjermbilde-2020-11-16-120315.png',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@500/skjermbilde-2020-11-16-120315.avif',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/60/@500/skjermbilde-2020-11-16-120315.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@500/skjermbilde-2020-11-16-120315.webp',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/60/@500/skjermbilde-2020-11-16-120315.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@500/skjermbilde-2020-11-16-120315.png',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/60/@500/skjermbilde-2020-11-16-120315.png',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@768/skjermbilde-2020-11-16-120315.avif',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/60/@768/skjermbilde-2020-11-16-120315.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@768/skjermbilde-2020-11-16-120315.webp',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/60/@768/skjermbilde-2020-11-16-120315.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@768/skjermbilde-2020-11-16-120315.png',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/60/@768/skjermbilde-2020-11-16-120315.png',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@1024/skjermbilde-2020-11-16-120315.avif',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/60/@1024/skjermbilde-2020-11-16-120315.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@1024/skjermbilde-2020-11-16-120315.webp',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/60/@1024/skjermbilde-2020-11-16-120315.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@1024/skjermbilde-2020-11-16-120315.png',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/60/@1024/skjermbilde-2020-11-16-120315.png',
                            },
                        ],
                    },
                    {
                        url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/skjermbilde-2020-11-16-120329.png',
                        key: 'bos-no-ecom-2/21/4/26/60/skjermbilde-2020-11-16-120329.png',
                        variants: [
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@100/skjermbilde-2020-11-16-120329.avif',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/60/@100/skjermbilde-2020-11-16-120329.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@100/skjermbilde-2020-11-16-120329.webp',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/60/@100/skjermbilde-2020-11-16-120329.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@100/skjermbilde-2020-11-16-120329.png',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/60/@100/skjermbilde-2020-11-16-120329.png',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@200/skjermbilde-2020-11-16-120329.avif',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/60/@200/skjermbilde-2020-11-16-120329.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@200/skjermbilde-2020-11-16-120329.webp',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/60/@200/skjermbilde-2020-11-16-120329.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@200/skjermbilde-2020-11-16-120329.png',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/60/@200/skjermbilde-2020-11-16-120329.png',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@500/skjermbilde-2020-11-16-120329.avif',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/60/@500/skjermbilde-2020-11-16-120329.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@500/skjermbilde-2020-11-16-120329.webp',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/60/@500/skjermbilde-2020-11-16-120329.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@500/skjermbilde-2020-11-16-120329.png',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/60/@500/skjermbilde-2020-11-16-120329.png',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@768/skjermbilde-2020-11-16-120329.avif',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/60/@768/skjermbilde-2020-11-16-120329.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@768/skjermbilde-2020-11-16-120329.webp',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/60/@768/skjermbilde-2020-11-16-120329.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@768/skjermbilde-2020-11-16-120329.png',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/60/@768/skjermbilde-2020-11-16-120329.png',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@1024/skjermbilde-2020-11-16-120329.avif',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/60/@1024/skjermbilde-2020-11-16-120329.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@1024/skjermbilde-2020-11-16-120329.webp',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/60/@1024/skjermbilde-2020-11-16-120329.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@1024/skjermbilde-2020-11-16-120329.png',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/60/@1024/skjermbilde-2020-11-16-120329.png',
                            },
                        ],
                    },
                    {
                        url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/skjermbilde-2020-11-16-120343.png',
                        key: 'bos-no-ecom-2/21/4/26/60/skjermbilde-2020-11-16-120343.png',
                        variants: [
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@100/skjermbilde-2020-11-16-120343.avif',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/60/@100/skjermbilde-2020-11-16-120343.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@100/skjermbilde-2020-11-16-120343.webp',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/60/@100/skjermbilde-2020-11-16-120343.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@100/skjermbilde-2020-11-16-120343.png',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/60/@100/skjermbilde-2020-11-16-120343.png',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@200/skjermbilde-2020-11-16-120343.avif',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/60/@200/skjermbilde-2020-11-16-120343.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@200/skjermbilde-2020-11-16-120343.webp',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/60/@200/skjermbilde-2020-11-16-120343.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@200/skjermbilde-2020-11-16-120343.png',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/60/@200/skjermbilde-2020-11-16-120343.png',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@500/skjermbilde-2020-11-16-120343.avif',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/60/@500/skjermbilde-2020-11-16-120343.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@500/skjermbilde-2020-11-16-120343.webp',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/60/@500/skjermbilde-2020-11-16-120343.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@500/skjermbilde-2020-11-16-120343.png',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/60/@500/skjermbilde-2020-11-16-120343.png',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@768/skjermbilde-2020-11-16-120343.avif',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/60/@768/skjermbilde-2020-11-16-120343.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@768/skjermbilde-2020-11-16-120343.webp',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/60/@768/skjermbilde-2020-11-16-120343.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@768/skjermbilde-2020-11-16-120343.png',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/60/@768/skjermbilde-2020-11-16-120343.png',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@1024/skjermbilde-2020-11-16-120343.avif',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/60/@1024/skjermbilde-2020-11-16-120343.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@1024/skjermbilde-2020-11-16-120343.webp',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/60/@1024/skjermbilde-2020-11-16-120343.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/60/@1024/skjermbilde-2020-11-16-120343.png',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/60/@1024/skjermbilde-2020-11-16-120343.png',
                            },
                        ],
                    },
                ],
            },
            components: [
                {
                    id: 'modelSeries',
                    content: null,
                },
                {
                    id: 'campaignText',
                    content: null,
                },
                {
                    id: 'seriesBrand',
                    content: {
                        text: 'EQC400 4M',
                    },
                },
                {
                    id: 'salesArticle',
                    content: {
                        text: 'EQC400 4M',
                    },
                },
                {
                    id: 'salesPackage',
                    content: {
                        text: 'AMG Edition Plus',
                    },
                },
                {
                    id: 'quoteText',
                    content: null,
                },
                {
                    id: 'standardInteriorCode',
                    content: {
                        text: '651',
                    },
                },
                {
                    id: 'standardRimCode',
                    content: {
                        text: 'RRR',
                    },
                },
                {
                    id: 'uniqueBrandIdentifier',
                    content: {
                        text: 'NO7',
                    },
                },
                {
                    id: 'standardEquipment',
                    content: {
                        chunks: [
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: '4MATIC firehjulstrekk',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'MBUX inkl. touchpad',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'MULTIBEAM LED-lys',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: '110 kw hurtiglader CCS',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'ladekabel for vanlig stikkontakt',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'ladekabel for wallbox',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Easy-pack elektrisk bakluke',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Keyless-GO komfortpakke.',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: '12V uttak i bagasjerom',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: '2 USB-uttak i baksetet',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'oppbevaringsrom i bagasjerom',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'mørke ruter bak.',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Forseter elektrisk justerbare i høyde og rygg',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: '4-veis korsryggstøtte',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'EQ Remote- og navigasjonstjenester',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'multifunksjonsratt i skinn',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'ISOFIX barnesetefester i ytre bakseter',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'EQ komfortunderstell m.m.',
                                    },
                                },
                            ],
                        ],
                    },
                },
                {
                    id: 'packageEquipment',
                    content: {
                        chunks: [
                            [
                                {
                                    id: 'packageEquipmentName',
                                    content: {
                                        text: 'AMG Interiør og AMG Eksteriør',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'packageEquipmentName',
                                    content: {
                                        text: 'sommer og vinterhjul',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'packageEquipmentName',
                                    content: {
                                        text: '20″ AMG lettmetallfelg',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'packageEquipmentName',
                                    content: {
                                        text: 'metallic lakk.',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'packageEquipmentName',
                                    content: {
                                        text: 'Aktiv avstandsassistent DISTRONIC med styreassistent',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'packageEquipmentName',
                                    content: {
                                        text: 'DISTRONIC Plus med styreassistent',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'packageEquipmentName',
                                    content: {
                                        text: 'PRE-SAFE® System.',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'packageEquipmentName',
                                    content: {
                                        text: 'Apple CarPlay',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'packageEquipmentName',
                                    content: {
                                        text: 'Android Auto.',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'packageEquipmentName',
                                    content: {
                                        text: 'Aktiv parkeringsasssistent med PARKTRONIC',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'packageEquipmentName',
                                    content: {
                                        text: '360° kamera',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'packageEquipmentName',
                                    content: {
                                        text: 'tilhengerfeste',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'packageEquipmentName',
                                    content: {
                                        text: 'bagasjeromsnett. Stigtrinn,skinn,Trådløs lading',
                                    },
                                },
                            ],
                        ],
                    },
                },
                {
                    id: 'equipmentHighlights',
                    content: {
                        chunks: [
                            [
                                {
                                    id: 'equipmentHighlightName',
                                    content: {
                                        text: '4MATIC firehjulstrekk',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'equipmentHighlightName',
                                    content: {
                                        text: 'Kjøreassistentpakke',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'equipmentHighlightName',
                                    content: {
                                        text: 'Stigtrinn',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'equipmentHighlightName',
                                    content: {
                                        text: 'Skinn',
                                    },
                                },
                            ],
                        ],
                    },
                },
                {
                    id: 'prices',
                    content: {
                        chunks: [
                            [
                                {
                                    id: 'netCustomerPriceIncludingVat',
                                    content: {
                                        number: 715200,
                                    },
                                },
                                {
                                    id: 'leasingBasisPrice',
                                    content: {
                                        number: 715200,
                                    },
                                },
                                {
                                    id: 'listPriceCar',
                                    content: {
                                        number: 627000,
                                    },
                                },
                                {
                                    id: 'listPricePackageCodes',
                                    content: {
                                        number: 80500,
                                    },
                                },
                                {
                                    id: 'importerSupportExcludingMva',
                                    content: {
                                        number: -20000,
                                    },
                                },
                                {
                                    id: 'leasingExtraCustomerAdvantage',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'packageDiscountWinterWheelsIncludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'customerAdvantageCarIncludingVat',
                                    content: {
                                        number: -37400,
                                    },
                                },
                                {
                                    id: 'deliveryCharge',
                                    content: {
                                        number: 9900,
                                    },
                                },
                                {
                                    id: 'vatCode',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'vehicleRoadTax',
                                    content: {
                                        number: 2400,
                                    },
                                },
                                {
                                    id: 'grossCustomerPriceExcluding',
                                    content: {
                                        number: 707500,
                                    },
                                },
                                {
                                    id: 'indicativePriceExcludingVat',
                                    content: {
                                        number: 705100,
                                    },
                                },
                                {
                                    id: 'retailerSupportExcludingVat',
                                    content: {
                                        number: -17400,
                                    },
                                },
                                {
                                    id: 'totalCustomerAdvantageIncludingVat',
                                    content: {
                                        number: -37400,
                                    },
                                },
                                {
                                    id: 'totalCustomerAdvantageExcludingVat',
                                    content: {
                                        number: -37400,
                                    },
                                },
                                {
                                    id: 'winterTiresWithMarkedPack',
                                    content: {
                                        number: 35200,
                                    },
                                },
                                {
                                    id: 'wreckage',
                                    content: {
                                        number: 2400,
                                    },
                                },
                                {
                                    id: 'dealerMarginCar',
                                    content: {
                                        number: 9,
                                    },
                                },
                                {
                                    id: 'dealerMarginPackageCodes',
                                    content: {
                                        number: 9,
                                    },
                                },
                                {
                                    id: 'retailerBasicMargin',
                                    content: {
                                        number: 63459,
                                    },
                                },
                                {
                                    id: 'retailerCampaignMarginLeasing',
                                    content: {
                                        number: 46059,
                                    },
                                },
                                {
                                    id: 'retailerCampaignMarginSale',
                                    content: {
                                        number: 46059,
                                    },
                                },
                                {
                                    id: 'residualValue3y30',
                                    content: {
                                        number: 425000,
                                    },
                                },
                                {
                                    id: 'residualValue3y45',
                                    content: {
                                        number: 410000,
                                    },
                                },
                                {
                                    id: 'residualValue3y60',
                                    content: {
                                        number: 390700,
                                    },
                                },
                                {
                                    id: 'residualValue4y40',
                                    content: {
                                        number: 370600,
                                    },
                                },
                                {
                                    id: 'residualValue4y60',
                                    content: {
                                        number: 343800,
                                    },
                                },
                                {
                                    id: 'leasingDepositExcludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'oneTimeLeasingFeeIncludingVat',
                                    content: {
                                        number: 4250,
                                    },
                                },
                                {
                                    id: 'oneTimeLoanFee',
                                    content: {
                                        number: 4250,
                                    },
                                },
                                {
                                    id: 'invoiceFeeLeasingIncludingVat',
                                    content: {
                                        number: 85,
                                    },
                                },
                                {
                                    id: 'invoiceFeeLoan',
                                    content: {
                                        number: 85,
                                    },
                                },
                                {
                                    id: 'leasingRate',
                                    content: {
                                        number: 1.99,
                                    },
                                },
                                {
                                    id: 'loanRate',
                                    content: {
                                        number: 2.48,
                                    },
                                },
                                {
                                    id: 'leasingDepositIncludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'leasingDepositIncludingVatAndOneTimeFee',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'calculationBaseLeasing',
                                    content: {
                                        number: 715200,
                                    },
                                },
                                {
                                    id: 'monthlyLeasing3y30',
                                    content: {
                                        number: 9086,
                                    },
                                },
                                {
                                    id: 'totalLeasing3y30',
                                    content: {
                                        number: 331334,
                                    },
                                },
                                {
                                    id: 'monthlyLeasing3y45',
                                    content: {
                                        number: 9490,
                                    },
                                },
                                {
                                    id: 'totalLeasing3y45',
                                    content: {
                                        number: 345879,
                                    },
                                },
                                {
                                    id: 'monthlyLeasing4y40',
                                    content: {
                                        number: 8161,
                                    },
                                },
                                {
                                    id: 'totalLeasing4y40',
                                    content: {
                                        number: 395969,
                                    },
                                },
                                {
                                    id: 'monthlyLoan5y35Equity',
                                    content: {
                                        number: 8409,
                                    },
                                },
                                {
                                    id: 'totalLoanCost5y35Equity',
                                    content: {
                                        number: 754845,
                                    },
                                },
                                {
                                    id: 'shortLegalTextLeasing3y30',
                                    content: {
                                        plainText: ['Startleie 0 kr / 36 mnd / 30 000 km / Nom. Rente 1.99%'],
                                    },
                                },
                                {
                                    id: 'longLegalTextLeasing3y30',
                                    content: null,
                                },
                                {
                                    id: 'shortLegalTextLeasing3y45',
                                    content: {
                                        plainText: ['Startleie 0 kr / 36 mnd / 45 000 km / Nom. Rente 1.99%'],
                                    },
                                },
                                {
                                    id: 'longLegalTextLeasing3y45',
                                    content: null,
                                },
                                {
                                    id: 'shortLegalTextLeasing4y40',
                                    content: {
                                        plainText: ['Startleie 0 kr / 48 mnd / 40 000 km / Nom. Rente 1.99%'],
                                    },
                                },
                                {
                                    id: 'longLegalTextLeasing4y40',
                                    content: null,
                                },
                                {
                                    id: 'shortLegalTextLoan',
                                    content: {
                                        plainText: ['35 % Egenkapital / 5 År / Nom. rente 2.49%'],
                                    },
                                },
                                {
                                    id: 'longLegalTextLoan',
                                    content: null,
                                },
                            ],
                        ],
                    },
                },
                {
                    id: 'varnishes',
                    content: {
                        chunks: [
                            [
                                {
                                    id: 'varnish',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2c3330a3f000a8b3896',
                                                name: 'High-tech silver - 922',
                                                defaultVariant: {
                                                    sku: 'EQC400 4M NO7-922',
                                                    priceVariants: null,
                                                    images: null,
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'paintDescription',
                                                        content: {
                                                            text: 'High-tech silver',
                                                        },
                                                    },
                                                    {
                                                        id: 'lacquerDescription',
                                                        content: {
                                                            text: 'Metallic',
                                                        },
                                                    },
                                                    {
                                                        id: 'paintCode',
                                                        content: {
                                                            text: '922',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2c2671b020008b11315',
                                                    name: 'Mercedes-Benz',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'varnishImages',
                                    content: null,
                                },
                                {
                                    id: 'isVarnishRecommended',
                                    content: {
                                        value: false,
                                    },
                                },
                                {
                                    id: 'varnishVatCode',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceIncludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceExcludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishRetailPrice',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginAmount',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishStandardPriceIncludingVat',
                                    content: {
                                        number: 6950,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginPercentage',
                                    content: {
                                        number: 13.85,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'varnish',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2c3330a3f000a8b3898',
                                                name: 'Hyacinth red metallic - 996',
                                                defaultVariant: {
                                                    sku: 'EQC400 4M NO7-996',
                                                    priceVariants: null,
                                                    images: null,
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'paintDescription',
                                                        content: {
                                                            text: 'Hyacinth red metallic',
                                                        },
                                                    },
                                                    {
                                                        id: 'lacquerDescription',
                                                        content: {
                                                            text: 'Metallic designo',
                                                        },
                                                    },
                                                    {
                                                        id: 'paintCode',
                                                        content: {
                                                            text: '996',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2c2671b020008b11315',
                                                    name: 'Mercedes-Benz',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'varnishImages',
                                    content: null,
                                },
                                {
                                    id: 'isVarnishRecommended',
                                    content: {
                                        value: false,
                                    },
                                },
                                {
                                    id: 'varnishVatCode',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceIncludingVat',
                                    content: {
                                        number: 2860,
                                    },
                                },
                                {
                                    id: 'varnishPriceExcludingVat',
                                    content: {
                                        number: 2860,
                                    },
                                },
                                {
                                    id: 'varnishRetailPrice',
                                    content: {
                                        number: 2464,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginAmount',
                                    content: {
                                        number: 396,
                                    },
                                },
                                {
                                    id: 'varnishStandardPriceIncludingVat',
                                    content: {
                                        number: 9810,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginPercentage',
                                    content: {
                                        number: 13.85,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'varnish',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2c3671b020008b11325',
                                                name: 'Graphite grey - 831',
                                                defaultVariant: {
                                                    sku: 'EQC400 4M NO7-831',
                                                    priceVariants: null,
                                                    images: null,
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'paintDescription',
                                                        content: {
                                                            text: 'Graphite grey',
                                                        },
                                                    },
                                                    {
                                                        id: 'lacquerDescription',
                                                        content: {
                                                            text: 'Metallic',
                                                        },
                                                    },
                                                    {
                                                        id: 'paintCode',
                                                        content: {
                                                            text: '831',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2c2671b020008b11315',
                                                    name: 'Mercedes-Benz',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'varnishImages',
                                    content: null,
                                },
                                {
                                    id: 'isVarnishRecommended',
                                    content: {
                                        value: false,
                                    },
                                },
                                {
                                    id: 'varnishVatCode',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceIncludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceExcludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishRetailPrice',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginAmount',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishStandardPriceIncludingVat',
                                    content: {
                                        number: 6950,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginPercentage',
                                    content: {
                                        number: 13.85,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'varnish',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2c3671b020008b11321',
                                                name: 'Obdsidian black - 197',
                                                defaultVariant: {
                                                    sku: 'EQC400 4M NO7-197',
                                                    priceVariants: null,
                                                    images: null,
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'paintDescription',
                                                        content: {
                                                            text: 'Obdsidian black',
                                                        },
                                                    },
                                                    {
                                                        id: 'lacquerDescription',
                                                        content: {
                                                            text: 'Metallic',
                                                        },
                                                    },
                                                    {
                                                        id: 'paintCode',
                                                        content: {
                                                            text: '197',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2c2671b020008b11315',
                                                    name: 'Mercedes-Benz',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'varnishImages',
                                    content: null,
                                },
                                {
                                    id: 'isVarnishRecommended',
                                    content: {
                                        value: false,
                                    },
                                },
                                {
                                    id: 'varnishVatCode',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceIncludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceExcludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishRetailPrice',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginAmount',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishStandardPriceIncludingVat',
                                    content: {
                                        number: 6950,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginPercentage',
                                    content: {
                                        number: 13.85,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'varnish',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2c33419880008366aab',
                                                name: 'Cavansite blue - 890',
                                                defaultVariant: {
                                                    sku: 'EQC400 4M NO7-890',
                                                    priceVariants: null,
                                                    images: null,
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'paintDescription',
                                                        content: {
                                                            text: 'Cavansite blue',
                                                        },
                                                    },
                                                    {
                                                        id: 'lacquerDescription',
                                                        content: {
                                                            text: 'Metallic',
                                                        },
                                                    },
                                                    {
                                                        id: 'paintCode',
                                                        content: {
                                                            text: '890',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2c2671b020008b11315',
                                                    name: 'Mercedes-Benz',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'varnishImages',
                                    content: null,
                                },
                                {
                                    id: 'isVarnishRecommended',
                                    content: {
                                        value: false,
                                    },
                                },
                                {
                                    id: 'varnishVatCode',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceIncludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceExcludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishRetailPrice',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginAmount',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishStandardPriceIncludingVat',
                                    content: {
                                        number: 6950,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginPercentage',
                                    content: {
                                        number: 13.85,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'varnish',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2c33419880008366aa7',
                                                name: 'Brilliantblue - 896',
                                                defaultVariant: {
                                                    sku: 'EQC400 4M NO7-896',
                                                    priceVariants: null,
                                                    images: null,
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'paintDescription',
                                                        content: {
                                                            text: 'Brilliantblue',
                                                        },
                                                    },
                                                    {
                                                        id: 'lacquerDescription',
                                                        content: {
                                                            text: 'Metallic',
                                                        },
                                                    },
                                                    {
                                                        id: 'paintCode',
                                                        content: {
                                                            text: '896',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2c2671b020008b11315',
                                                    name: 'Mercedes-Benz',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'varnishImages',
                                    content: null,
                                },
                                {
                                    id: 'isVarnishRecommended',
                                    content: {
                                        value: false,
                                    },
                                },
                                {
                                    id: 'varnishVatCode',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceIncludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceExcludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishRetailPrice',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginAmount',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishStandardPriceIncludingVat',
                                    content: {
                                        number: 6950,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginPercentage',
                                    content: {
                                        number: 13.85,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'varnish',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2c3330a3f000a8b389f',
                                                name: 'Selenite grey - 992',
                                                defaultVariant: {
                                                    sku: 'EQC400 4M NO7-992',
                                                    priceVariants: null,
                                                    images: null,
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'paintDescription',
                                                        content: {
                                                            text: 'Selenite grey',
                                                        },
                                                    },
                                                    {
                                                        id: 'lacquerDescription',
                                                        content: {
                                                            text: 'Metallic',
                                                        },
                                                    },
                                                    {
                                                        id: 'paintCode',
                                                        content: {
                                                            text: '992',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2c2671b020008b11315',
                                                    name: 'Mercedes-Benz',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'varnishImages',
                                    content: null,
                                },
                                {
                                    id: 'isVarnishRecommended',
                                    content: {
                                        value: false,
                                    },
                                },
                                {
                                    id: 'varnishVatCode',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceIncludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceExcludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishRetailPrice',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginAmount',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishStandardPriceIncludingVat',
                                    content: {
                                        number: 6950,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginPercentage',
                                    content: {
                                        number: 13.85,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'varnish',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2c33419880008366ab1',
                                                name: 'Selenite grey magno - 297',
                                                defaultVariant: {
                                                    sku: 'EQC400 4M NO7-297',
                                                    priceVariants: null,
                                                    images: null,
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'paintDescription',
                                                        content: {
                                                            text: 'Selenite grey magno',
                                                        },
                                                    },
                                                    {
                                                        id: 'lacquerDescription',
                                                        content: {
                                                            text: 'Metallic designo',
                                                        },
                                                    },
                                                    {
                                                        id: 'paintCode',
                                                        content: {
                                                            text: '297',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2c2671b020008b11315',
                                                    name: 'Mercedes-Benz',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'varnishImages',
                                    content: null,
                                },
                                {
                                    id: 'isVarnishRecommended',
                                    content: {
                                        value: false,
                                    },
                                },
                                {
                                    id: 'varnishVatCode',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceIncludingVat',
                                    content: {
                                        number: 11460,
                                    },
                                },
                                {
                                    id: 'varnishPriceExcludingVat',
                                    content: {
                                        number: 11460,
                                    },
                                },
                                {
                                    id: 'varnishRetailPrice',
                                    content: {
                                        number: 9873,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginAmount',
                                    content: {
                                        number: 1587,
                                    },
                                },
                                {
                                    id: 'varnishStandardPriceIncludingVat',
                                    content: {
                                        number: 18410,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginPercentage',
                                    content: {
                                        number: 13.85,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'varnish',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2c33419880008366ab7',
                                                name: 'Diamond white bright - 799',
                                                defaultVariant: {
                                                    sku: 'EQC400 4M NO7-799',
                                                    priceVariants: null,
                                                    images: null,
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'paintDescription',
                                                        content: {
                                                            text: 'Diamond white bright',
                                                        },
                                                    },
                                                    {
                                                        id: 'lacquerDescription',
                                                        content: {
                                                            text: 'Metallic designo',
                                                        },
                                                    },
                                                    {
                                                        id: 'paintCode',
                                                        content: {
                                                            text: '799',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2c2671b020008b11315',
                                                    name: 'Mercedes-Benz',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'varnishImages',
                                    content: null,
                                },
                                {
                                    id: 'isVarnishRecommended',
                                    content: {
                                        value: false,
                                    },
                                },
                                {
                                    id: 'varnishVatCode',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceIncludingVat',
                                    content: {
                                        number: 5870,
                                    },
                                },
                                {
                                    id: 'varnishPriceExcludingVat',
                                    content: {
                                        number: 5870,
                                    },
                                },
                                {
                                    id: 'varnishRetailPrice',
                                    content: {
                                        number: 5057,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginAmount',
                                    content: {
                                        number: 813,
                                    },
                                },
                                {
                                    id: 'varnishStandardPriceIncludingVat',
                                    content: {
                                        number: 12820,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginPercentage',
                                    content: {
                                        number: 13.85,
                                    },
                                },
                            ],
                        ],
                    },
                },
                {
                    id: 'accessories',
                    content: {
                        chunks: [
                            [
                                {
                                    id: 'accessory',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2dc671b020008b114c9',
                                                name: 'Adapter A1778202901',
                                                defaultVariant: {
                                                    sku: 'A1778202901',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/177/a1778202901.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/177/a1778202901.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/177/@100/a1778202901.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/177/@100/a1778202901.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/177/@100/a1778202901.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/177/@100/a1778202901.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/177/@100/a1778202901.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/177/@100/a1778202901.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/177/@200/a1778202901.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/177/@200/a1778202901.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/177/@200/a1778202901.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/177/@200/a1778202901.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/177/@200/a1778202901.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/177/@200/a1778202901.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/177/@500/a1778202901.avif',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/177/@500/a1778202901.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/177/@500/a1778202901.webp',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/177/@500/a1778202901.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/177/@500/a1778202901.jpeg',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/177/@500/a1778202901.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/177/@768/a1778202901.avif',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/177/@768/a1778202901.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/177/@768/a1778202901.webp',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/177/@768/a1778202901.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/177/@768/a1778202901.jpeg',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/177/@768/a1778202901.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/177/@1024/a1778202901.avif',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/177/@1024/a1778202901.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/177/@1024/a1778202901.webp',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/177/@1024/a1778202901.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/177/@1024/a1778202901.jpeg',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/177/@1024/a1778202901.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/177/@1366/a1778202901.avif',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/177/@1366/a1778202901.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/177/@1366/a1778202901.webp',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/177/@1366/a1778202901.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/177/@1366/a1778202901.jpeg',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/177/@1366/a1778202901.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/177/@1600/a1778202901.avif',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/177/@1600/a1778202901.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/177/@1600/a1778202901.webp',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/177/@1600/a1778202901.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/177/@1600/a1778202901.jpeg',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/177/@1600/a1778202901.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/177/@1920/a1778202901.avif',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/177/@1920/a1778202901.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/177/@1920/a1778202901.webp',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/177/@1920/a1778202901.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/177/@1920/a1778202901.jpeg',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/177/@1920/a1778202901.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/177/@3200/a1778202901.avif',
                                                                    width: 3200,
                                                                    key: 'bos-no-ecom-2/21/4/26/177/@3200/a1778202901.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/177/@3200/a1778202901.webp',
                                                                    width: 3200,
                                                                    key: 'bos-no-ecom-2/21/4/26/177/@3200/a1778202901.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/177/@3200/a1778202901.jpeg',
                                                                    width: 3200,
                                                                    key: 'bos-no-ecom-2/21/4/26/177/@3200/a1778202901.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'MI adapter kabel NTG6 - A1778202901',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleNumber',
                                                        content: {
                                                            text: 'A1778202901',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleName',
                                                        content: {
                                                            text: 'Adapter',
                                                        },
                                                    },
                                                    {
                                                        id: 'brandSpecific',
                                                        content: {
                                                            value: true,
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2db671b020008b114bc',
                                                    name: 'Mercedes-Benz',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'accessoryTimeAssembly',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryIndicativePriceExcludingVatAndAssembly',
                                    content: {
                                        number: 214,
                                    },
                                },
                                {
                                    id: 'accessoryAssemblyPriceExcludingVat',
                                    content: {
                                        number: 1200,
                                    },
                                },
                                {
                                    id: 'accessoryVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryVatEl',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatIce',
                                    content: {
                                        number: 270,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatEl',
                                    content: {
                                        number: 270,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatIce',
                                    content: {
                                        number: 216,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatEl',
                                    content: {
                                        number: 216,
                                    },
                                },
                                {
                                    id: 'accessoryRetailPriceExcludingVat',
                                    content: {
                                        number: 182,
                                    },
                                },
                                {
                                    id: 'accessoryRetailerMargin',
                                    content: {
                                        number: 32,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'accessory',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2dc671b020008b114cf',
                                                name: 'Lasterholder A2938900000',
                                                defaultVariant: {
                                                    sku: 'A2938900000',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/127/lasteholder-.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/127/lasteholder-.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/127/@100/lasteholder-.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/127/@100/lasteholder-.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/127/@100/lasteholder-.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/127/@100/lasteholder-.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/127/@100/lasteholder-.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/127/@100/lasteholder-.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/127/@200/lasteholder-.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/127/@200/lasteholder-.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/127/@200/lasteholder-.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/127/@200/lasteholder-.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/127/@200/lasteholder-.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/127/@200/lasteholder-.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/127/@500/lasteholder-.avif',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/127/@500/lasteholder-.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/127/@500/lasteholder-.webp',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/127/@500/lasteholder-.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/127/@500/lasteholder-.jpeg',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/127/@500/lasteholder-.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/127/@768/lasteholder-.avif',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/127/@768/lasteholder-.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/127/@768/lasteholder-.webp',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/127/@768/lasteholder-.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/127/@768/lasteholder-.jpeg',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/127/@768/lasteholder-.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/127/@1024/lasteholder-.avif',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/127/@1024/lasteholder-.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/127/@1024/lasteholder-.webp',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/127/@1024/lasteholder-.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/127/@1024/lasteholder-.jpeg',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/127/@1024/lasteholder-.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/127/@1366/lasteholder-.avif',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/127/@1366/lasteholder-.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/127/@1366/lasteholder-.webp',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/127/@1366/lasteholder-.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/127/@1366/lasteholder-.jpeg',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/127/@1366/lasteholder-.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/127/@1600/lasteholder-.avif',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/127/@1600/lasteholder-.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/127/@1600/lasteholder-.webp',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/127/@1600/lasteholder-.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/127/@1600/lasteholder-.jpeg',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/127/@1600/lasteholder-.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/127/@1920/lasteholder-.avif',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/127/@1920/lasteholder-.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/127/@1920/lasteholder-.webp',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/127/@1920/lasteholder-.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/127/@1920/lasteholder-.jpeg',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/127/@1920/lasteholder-.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/127/@3200/lasteholder-.avif',
                                                                    width: 3200,
                                                                    key: 'bos-no-ecom-2/21/4/26/127/@3200/lasteholder-.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/127/@3200/lasteholder-.webp',
                                                                    width: 3200,
                                                                    key: 'bos-no-ecom-2/21/4/26/127/@3200/lasteholder-.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/127/@3200/lasteholder-.jpeg',
                                                                    width: 3200,
                                                                    key: 'bos-no-ecom-2/21/4/26/127/@3200/lasteholder-.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'Lasteholder Mercedes-Benz - A2938900000',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleNumber',
                                                        content: {
                                                            text: 'A2938900000',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleName',
                                                        content: {
                                                            text: 'Lasterholder',
                                                        },
                                                    },
                                                    {
                                                        id: 'brandSpecific',
                                                        content: {
                                                            value: true,
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2db671b020008b114bc',
                                                    name: 'Mercedes-Benz',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'accessoryTimeAssembly',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryIndicativePriceExcludingVatAndAssembly',
                                    content: {
                                        number: 3151,
                                    },
                                },
                                {
                                    id: 'accessoryAssemblyPriceExcludingVat',
                                    content: {
                                        number: 1200,
                                    },
                                },
                                {
                                    id: 'accessoryVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryVatEl',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatIce',
                                    content: {
                                        number: 3940,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatEl',
                                    content: {
                                        number: 3940,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatIce',
                                    content: {
                                        number: 3152,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatEl',
                                    content: {
                                        number: 3152,
                                    },
                                },
                                {
                                    id: 'accessoryRetailPriceExcludingVat',
                                    content: {
                                        number: 2678,
                                    },
                                },
                                {
                                    id: 'accessoryRetailerMargin',
                                    content: {
                                        number: 473,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'accessory',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2dc671b020008b114cd',
                                                name: 'Modellbil B66963758',
                                                defaultVariant: {
                                                    sku: 'B66963758',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/104/b66963758.png',
                                                            key: 'bos-no-ecom-2/21/4/26/104/b66963758.png',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/104/@100/b66963758.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/104/@100/b66963758.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/104/@100/b66963758.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/104/@100/b66963758.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/104/@100/b66963758.png',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/104/@100/b66963758.png',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/104/@200/b66963758.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/104/@200/b66963758.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/104/@200/b66963758.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/104/@200/b66963758.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/104/@200/b66963758.png',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/104/@200/b66963758.png',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/104/@500/b66963758.avif',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/104/@500/b66963758.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/104/@500/b66963758.webp',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/104/@500/b66963758.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/104/@500/b66963758.png',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/104/@500/b66963758.png',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/104/@768/b66963758.avif',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/104/@768/b66963758.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/104/@768/b66963758.webp',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/104/@768/b66963758.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/104/@768/b66963758.png',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/104/@768/b66963758.png',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/104/@1024/b66963758.avif',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/104/@1024/b66963758.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/104/@1024/b66963758.webp',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/104/@1024/b66963758.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/104/@1024/b66963758.png',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/104/@1024/b66963758.png',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/104/@1366/b66963758.avif',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/104/@1366/b66963758.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/104/@1366/b66963758.webp',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/104/@1366/b66963758.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/104/@1366/b66963758.png',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/104/@1366/b66963758.png',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/104/@1600/b66963758.avif',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/104/@1600/b66963758.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/104/@1600/b66963758.webp',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/104/@1600/b66963758.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/104/@1600/b66963758.png',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/104/@1600/b66963758.png',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/104/@1920/b66963758.avif',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/104/@1920/b66963758.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/104/@1920/b66963758.webp',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/104/@1920/b66963758.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/104/@1920/b66963758.png',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/104/@1920/b66963758.png',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/104/@3200/b66963758.avif',
                                                                    width: 3200,
                                                                    key: 'bos-no-ecom-2/21/4/26/104/@3200/b66963758.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/104/@3200/b66963758.webp',
                                                                    width: 3200,
                                                                    key: 'bos-no-ecom-2/21/4/26/104/@3200/b66963758.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/104/@3200/b66963758.png',
                                                                    width: 3200,
                                                                    key: 'bos-no-ecom-2/21/4/26/104/@3200/b66963758.png',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'Modellbil EQC Graphite grey (1:18) - B66963758',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleNumber',
                                                        content: {
                                                            text: 'B66963758',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleName',
                                                        content: {
                                                            text: 'Modellbil',
                                                        },
                                                    },
                                                    {
                                                        id: 'brandSpecific',
                                                        content: {
                                                            value: true,
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2db671b020008b114bc',
                                                    name: 'Mercedes-Benz',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'accessoryTimeAssembly',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryIndicativePriceExcludingVatAndAssembly',
                                    content: {
                                        number: 2018,
                                    },
                                },
                                {
                                    id: 'accessoryAssemblyPriceExcludingVat',
                                    content: {
                                        number: 1200,
                                    },
                                },
                                {
                                    id: 'accessoryVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryVatEl',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatIce',
                                    content: {
                                        number: 2530,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatEl',
                                    content: {
                                        number: 2530,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatIce',
                                    content: {
                                        number: 2024,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatEl',
                                    content: {
                                        number: 2024,
                                    },
                                },
                                {
                                    id: 'accessoryRetailPriceExcludingVat',
                                    content: {
                                        number: 1715,
                                    },
                                },
                                {
                                    id: 'accessoryRetailerMargin',
                                    content: {
                                        number: 303,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'accessory',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2dc671b020008b114d6',
                                                name: 'Navkopper A17140001259040',
                                                defaultVariant: {
                                                    sku: 'A17140001259040',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/118/a17140001259040.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/118/a17140001259040.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/118/@100/a17140001259040.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/118/@100/a17140001259040.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/118/@100/a17140001259040.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/118/@100/a17140001259040.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/118/@100/a17140001259040.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/118/@100/a17140001259040.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/118/@200/a17140001259040.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/118/@200/a17140001259040.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/118/@200/a17140001259040.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/118/@200/a17140001259040.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/118/@200/a17140001259040.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/118/@200/a17140001259040.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/118/@500/a17140001259040.avif',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/118/@500/a17140001259040.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/118/@500/a17140001259040.webp',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/118/@500/a17140001259040.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/118/@500/a17140001259040.jpeg',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/118/@500/a17140001259040.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/118/@768/a17140001259040.avif',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/118/@768/a17140001259040.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/118/@768/a17140001259040.webp',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/118/@768/a17140001259040.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/118/@768/a17140001259040.jpeg',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/118/@768/a17140001259040.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/118/@1024/a17140001259040.avif',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/118/@1024/a17140001259040.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/118/@1024/a17140001259040.webp',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/118/@1024/a17140001259040.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/118/@1024/a17140001259040.jpeg',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/118/@1024/a17140001259040.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/118/@1366/a17140001259040.avif',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/118/@1366/a17140001259040.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/118/@1366/a17140001259040.webp',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/118/@1366/a17140001259040.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/118/@1366/a17140001259040.jpeg',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/118/@1366/a17140001259040.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/118/@1600/a17140001259040.avif',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/118/@1600/a17140001259040.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/118/@1600/a17140001259040.webp',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/118/@1600/a17140001259040.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/118/@1600/a17140001259040.jpeg',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/118/@1600/a17140001259040.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/118/@1920/a17140001259040.avif',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/118/@1920/a17140001259040.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/118/@1920/a17140001259040.webp',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/118/@1920/a17140001259040.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/118/@1920/a17140001259040.jpeg',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/118/@1920/a17140001259040.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'Navkopper sett a 4 stk - A17140001259040',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleNumber',
                                                        content: {
                                                            text: 'A17140001259040',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleName',
                                                        content: {
                                                            text: 'Navkopper',
                                                        },
                                                    },
                                                    {
                                                        id: 'brandSpecific',
                                                        content: {
                                                            value: true,
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2db671b020008b114bc',
                                                    name: 'Mercedes-Benz',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'accessoryTimeAssembly',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryIndicativePriceExcludingVatAndAssembly',
                                    content: {
                                        number: 625,
                                    },
                                },
                                {
                                    id: 'accessoryAssemblyPriceExcludingVat',
                                    content: {
                                        number: 1200,
                                    },
                                },
                                {
                                    id: 'accessoryVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryVatEl',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatIce',
                                    content: {
                                        number: 790,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatEl',
                                    content: {
                                        number: 630,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatIce',
                                    content: {
                                        number: 632,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatEl',
                                    content: {
                                        number: 630,
                                    },
                                },
                                {
                                    id: 'accessoryRetailPriceExcludingVat',
                                    content: {
                                        number: 531,
                                    },
                                },
                                {
                                    id: 'accessoryRetailerMargin',
                                    content: {
                                        number: 94,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'accessory',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2dc330a3f000a8b3a42',
                                                name: 'Bagasjeromsmatte MER6031',
                                                defaultVariant: {
                                                    sku: 'MER6031',
                                                    priceVariants: null,
                                                    images: null,
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'Bagasjeromsmatte gummi - MER6031',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleNumber',
                                                        content: {
                                                            text: 'MER6031',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleName',
                                                        content: {
                                                            text: 'Bagasjeromsmatte',
                                                        },
                                                    },
                                                    {
                                                        id: 'brandSpecific',
                                                        content: {
                                                            value: true,
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2db671b020008b114bc',
                                                    name: 'Mercedes-Benz',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'accessoryTimeAssembly',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryIndicativePriceExcludingVatAndAssembly',
                                    content: {
                                        number: 790,
                                    },
                                },
                                {
                                    id: 'accessoryAssemblyPriceExcludingVat',
                                    content: {
                                        number: 1200,
                                    },
                                },
                                {
                                    id: 'accessoryVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryVatEl',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatIce',
                                    content: {
                                        number: 990,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatEl',
                                    content: {
                                        number: 790,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatIce',
                                    content: {
                                        number: 792,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatEl',
                                    content: {
                                        number: 790,
                                    },
                                },
                                {
                                    id: 'accessoryRetailPriceExcludingVat',
                                    content: {
                                        number: 672,
                                    },
                                },
                                {
                                    id: 'accessoryRetailerMargin',
                                    content: {
                                        number: 119,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'accessory',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2dc330a3f000a8b3a45',
                                                name: 'Gummimatter A25368037039G33',
                                                defaultVariant: {
                                                    sku: 'A25368037039G33',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/135/gummimattesett-foran.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/135/gummimattesett-foran.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/135/@100/gummimattesett-foran.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/135/@100/gummimattesett-foran.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/135/@100/gummimattesett-foran.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/135/@100/gummimattesett-foran.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/135/@100/gummimattesett-foran.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/135/@100/gummimattesett-foran.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/135/@200/gummimattesett-foran.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/135/@200/gummimattesett-foran.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/135/@200/gummimattesett-foran.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/135/@200/gummimattesett-foran.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/135/@200/gummimattesett-foran.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/135/@200/gummimattesett-foran.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/135/@500/gummimattesett-foran.avif',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/135/@500/gummimattesett-foran.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/135/@500/gummimattesett-foran.webp',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/135/@500/gummimattesett-foran.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/135/@500/gummimattesett-foran.jpeg',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/135/@500/gummimattesett-foran.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/135/@768/gummimattesett-foran.avif',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/135/@768/gummimattesett-foran.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/135/@768/gummimattesett-foran.webp',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/135/@768/gummimattesett-foran.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/135/@768/gummimattesett-foran.jpeg',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/135/@768/gummimattesett-foran.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/135/@1024/gummimattesett-foran.avif',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/135/@1024/gummimattesett-foran.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/135/@1024/gummimattesett-foran.webp',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/135/@1024/gummimattesett-foran.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/135/@1024/gummimattesett-foran.jpeg',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/135/@1024/gummimattesett-foran.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/135/@1366/gummimattesett-foran.avif',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/135/@1366/gummimattesett-foran.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/135/@1366/gummimattesett-foran.webp',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/135/@1366/gummimattesett-foran.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/135/@1366/gummimattesett-foran.jpeg',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/135/@1366/gummimattesett-foran.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/135/@1600/gummimattesett-foran.avif',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/135/@1600/gummimattesett-foran.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/135/@1600/gummimattesett-foran.webp',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/135/@1600/gummimattesett-foran.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/135/@1600/gummimattesett-foran.jpeg',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/135/@1600/gummimattesett-foran.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/135/@1920/gummimattesett-foran.avif',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/135/@1920/gummimattesett-foran.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/135/@1920/gummimattesett-foran.webp',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/135/@1920/gummimattesett-foran.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/135/@1920/gummimattesett-foran.jpeg',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/135/@1920/gummimattesett-foran.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/135/@3200/gummimattesett-foran.avif',
                                                                    width: 3200,
                                                                    key: 'bos-no-ecom-2/21/4/26/135/@3200/gummimattesett-foran.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/135/@3200/gummimattesett-foran.webp',
                                                                    width: 3200,
                                                                    key: 'bos-no-ecom-2/21/4/26/135/@3200/gummimattesett-foran.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/135/@3200/gummimattesett-foran.jpeg',
                                                                    width: 3200,
                                                                    key: 'bos-no-ecom-2/21/4/26/135/@3200/gummimattesett-foran.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'Gummimatter foran - A25368037039G33',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleNumber',
                                                        content: {
                                                            text: 'A25368037039G33',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleName',
                                                        content: {
                                                            text: 'Gummimatter',
                                                        },
                                                    },
                                                    {
                                                        id: 'brandSpecific',
                                                        content: {
                                                            value: true,
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2db671b020008b114bc',
                                                    name: 'Mercedes-Benz',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'accessoryTimeAssembly',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryIndicativePriceExcludingVatAndAssembly',
                                    content: {
                                        number: 766,
                                    },
                                },
                                {
                                    id: 'accessoryAssemblyPriceExcludingVat',
                                    content: {
                                        number: 1200,
                                    },
                                },
                                {
                                    id: 'accessoryVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryVatEl',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatIce',
                                    content: {
                                        number: 960,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatEl',
                                    content: {
                                        number: 770,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatIce',
                                    content: {
                                        number: 768,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatEl',
                                    content: {
                                        number: 770,
                                    },
                                },
                                {
                                    id: 'accessoryRetailPriceExcludingVat',
                                    content: {
                                        number: 651,
                                    },
                                },
                                {
                                    id: 'accessoryRetailerMargin',
                                    content: {
                                        number: 115,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'accessory',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2dc330a3f000a8b3a4a',
                                                name: 'Sykkeholder A0008901700',
                                                defaultVariant: {
                                                    sku: 'A0008901700',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/179/2-sykler-a0008901700-for-3-sykler-a0008901800.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/179/2-sykler-a0008901700-for-3-sykler-a0008901800.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/179/@100/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/179/@100/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/179/@100/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/179/@100/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/179/@100/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/179/@100/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/179/@200/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/179/@200/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/179/@200/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/179/@200/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/179/@200/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/179/@200/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/179/@500/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/179/@500/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/179/@500/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/179/@500/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/179/@500/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/179/@500/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/179/@768/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/179/@768/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/179/@768/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/179/@768/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/179/@768/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/179/@768/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/179/@1024/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/179/@1024/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/179/@1024/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/179/@1024/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/179/@1024/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/179/@1024/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/179/@1366/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/179/@1366/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/179/@1366/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/179/@1366/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/179/@1366/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/179/@1366/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/179/@1600/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/179/@1600/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/179/@1600/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/179/@1600/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/179/@1600/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/179/@1600/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/179/@1920/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/179/@1920/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/179/@1920/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/179/@1920/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/179/@1920/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/179/@1920/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'Sykkelholder bak (2 sykler) - A0008901700',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleNumber',
                                                        content: {
                                                            text: 'A0008901700',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleName',
                                                        content: {
                                                            text: 'Sykkeholder',
                                                        },
                                                    },
                                                    {
                                                        id: 'brandSpecific',
                                                        content: {
                                                            value: true,
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2db671b020008b114bc',
                                                    name: 'Mercedes-Benz',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'accessoryTimeAssembly',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryIndicativePriceExcludingVatAndAssembly',
                                    content: {
                                        number: 7660,
                                    },
                                },
                                {
                                    id: 'accessoryAssemblyPriceExcludingVat',
                                    content: {
                                        number: 1200,
                                    },
                                },
                                {
                                    id: 'accessoryVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryVatEl',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatIce',
                                    content: {
                                        number: 9580,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatEl',
                                    content: {
                                        number: 9580,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatIce',
                                    content: {
                                        number: 7664,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatEl',
                                    content: {
                                        number: 7664,
                                    },
                                },
                                {
                                    id: 'accessoryRetailPriceExcludingVat',
                                    content: {
                                        number: 6511,
                                    },
                                },
                                {
                                    id: 'accessoryRetailerMargin',
                                    content: {
                                        number: 1149,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'accessory',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2dc3419880008366c50',
                                                name: 'Speildeksel A2058110100',
                                                defaultVariant: {
                                                    sku: 'A2058110100',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/111/a2058110100.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/111/a2058110100.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/111/@100/a2058110100.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/111/@100/a2058110100.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/111/@100/a2058110100.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/111/@100/a2058110100.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/111/@100/a2058110100.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/111/@100/a2058110100.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/111/@200/a2058110100.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/111/@200/a2058110100.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/111/@200/a2058110100.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/111/@200/a2058110100.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/111/@200/a2058110100.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/111/@200/a2058110100.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/111/@500/a2058110100.avif',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/111/@500/a2058110100.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/111/@500/a2058110100.webp',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/111/@500/a2058110100.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/111/@500/a2058110100.jpeg',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/111/@500/a2058110100.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/111/@768/a2058110100.avif',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/111/@768/a2058110100.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/111/@768/a2058110100.webp',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/111/@768/a2058110100.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/111/@768/a2058110100.jpeg',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/111/@768/a2058110100.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/111/@1024/a2058110100.avif',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/111/@1024/a2058110100.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/111/@1024/a2058110100.webp',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/111/@1024/a2058110100.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/111/@1024/a2058110100.jpeg',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/111/@1024/a2058110100.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/111/@1366/a2058110100.avif',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/111/@1366/a2058110100.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/111/@1366/a2058110100.webp',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/111/@1366/a2058110100.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/111/@1366/a2058110100.jpeg',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/111/@1366/a2058110100.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/111/@1600/a2058110100.avif',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/111/@1600/a2058110100.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/111/@1600/a2058110100.webp',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/111/@1600/a2058110100.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/111/@1600/a2058110100.jpeg',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/111/@1600/a2058110100.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'Speildeksel carbon stil - A2058110100',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleNumber',
                                                        content: {
                                                            text: 'A2058110100',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleName',
                                                        content: {
                                                            text: 'Speildeksel',
                                                        },
                                                    },
                                                    {
                                                        id: 'brandSpecific',
                                                        content: {
                                                            value: true,
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2db671b020008b114bc',
                                                    name: 'Mercedes-Benz',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'accessoryTimeAssembly',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryIndicativePriceExcludingVatAndAssembly',
                                    content: {
                                        number: 2544,
                                    },
                                },
                                {
                                    id: 'accessoryAssemblyPriceExcludingVat',
                                    content: {
                                        number: 1200,
                                    },
                                },
                                {
                                    id: 'accessoryVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryVatEl',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatIce',
                                    content: {
                                        number: 3190,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatEl',
                                    content: {
                                        number: 3190,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatIce',
                                    content: {
                                        number: 2552,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatEl',
                                    content: {
                                        number: 2552,
                                    },
                                },
                                {
                                    id: 'accessoryRetailPriceExcludingVat',
                                    content: {
                                        number: 2163,
                                    },
                                },
                                {
                                    id: 'accessoryRetailerMargin',
                                    content: {
                                        number: 382,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'accessory',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2dc3419880008366c52',
                                                name: 'Gummimatter A25368038039G33',
                                                defaultVariant: {
                                                    sku: 'A25368038039G33',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/100/gummimattesett-bak.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/100/gummimattesett-bak.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/100/@100/gummimattesett-bak.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/100/@100/gummimattesett-bak.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/100/@100/gummimattesett-bak.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/100/@100/gummimattesett-bak.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/100/@100/gummimattesett-bak.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/100/@100/gummimattesett-bak.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/100/@200/gummimattesett-bak.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/100/@200/gummimattesett-bak.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/100/@200/gummimattesett-bak.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/100/@200/gummimattesett-bak.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/100/@200/gummimattesett-bak.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/100/@200/gummimattesett-bak.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/100/@500/gummimattesett-bak.avif',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/100/@500/gummimattesett-bak.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/100/@500/gummimattesett-bak.webp',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/100/@500/gummimattesett-bak.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/100/@500/gummimattesett-bak.jpeg',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/100/@500/gummimattesett-bak.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/100/@768/gummimattesett-bak.avif',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/100/@768/gummimattesett-bak.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/100/@768/gummimattesett-bak.webp',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/100/@768/gummimattesett-bak.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/100/@768/gummimattesett-bak.jpeg',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/100/@768/gummimattesett-bak.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/100/@1024/gummimattesett-bak.avif',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/100/@1024/gummimattesett-bak.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/100/@1024/gummimattesett-bak.webp',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/100/@1024/gummimattesett-bak.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/100/@1024/gummimattesett-bak.jpeg',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/100/@1024/gummimattesett-bak.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/100/@1366/gummimattesett-bak.avif',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/100/@1366/gummimattesett-bak.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/100/@1366/gummimattesett-bak.webp',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/100/@1366/gummimattesett-bak.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/100/@1366/gummimattesett-bak.jpeg',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/100/@1366/gummimattesett-bak.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/100/@1600/gummimattesett-bak.avif',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/100/@1600/gummimattesett-bak.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/100/@1600/gummimattesett-bak.webp',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/100/@1600/gummimattesett-bak.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/100/@1600/gummimattesett-bak.jpeg',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/100/@1600/gummimattesett-bak.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/100/@1920/gummimattesett-bak.avif',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/100/@1920/gummimattesett-bak.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/100/@1920/gummimattesett-bak.webp',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/100/@1920/gummimattesett-bak.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/100/@1920/gummimattesett-bak.jpeg',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/100/@1920/gummimattesett-bak.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/100/@3200/gummimattesett-bak.avif',
                                                                    width: 3200,
                                                                    key: 'bos-no-ecom-2/21/4/26/100/@3200/gummimattesett-bak.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/100/@3200/gummimattesett-bak.webp',
                                                                    width: 3200,
                                                                    key: 'bos-no-ecom-2/21/4/26/100/@3200/gummimattesett-bak.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/100/@3200/gummimattesett-bak.jpeg',
                                                                    width: 3200,
                                                                    key: 'bos-no-ecom-2/21/4/26/100/@3200/gummimattesett-bak.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'Gummimatter bak - A25368038039G33',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleNumber',
                                                        content: {
                                                            text: 'A25368038039G33',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleName',
                                                        content: {
                                                            text: 'Gummimatter',
                                                        },
                                                    },
                                                    {
                                                        id: 'brandSpecific',
                                                        content: {
                                                            value: true,
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2db671b020008b114bc',
                                                    name: 'Mercedes-Benz',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'accessoryTimeAssembly',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryIndicativePriceExcludingVatAndAssembly',
                                    content: {
                                        number: 416,
                                    },
                                },
                                {
                                    id: 'accessoryAssemblyPriceExcludingVat',
                                    content: {
                                        number: 1200,
                                    },
                                },
                                {
                                    id: 'accessoryVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryVatEl',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatIce',
                                    content: {
                                        number: 520,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatEl',
                                    content: {
                                        number: 420,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatIce',
                                    content: {
                                        number: 416,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatEl',
                                    content: {
                                        number: 420,
                                    },
                                },
                                {
                                    id: 'accessoryRetailPriceExcludingVat',
                                    content: {
                                        number: 353,
                                    },
                                },
                                {
                                    id: 'accessoryRetailerMargin',
                                    content: {
                                        number: 62,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'accessory',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2dc3419880008366c5d',
                                                name: 'Barnesete A0009701302',
                                                defaultVariant: {
                                                    sku: 'A0009701302',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/94/a0009701302.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/94/a0009701302.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/94/@100/a0009701302.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/94/@100/a0009701302.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/94/@100/a0009701302.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/94/@100/a0009701302.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/94/@100/a0009701302.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/94/@100/a0009701302.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/94/@200/a0009701302.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/94/@200/a0009701302.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/94/@200/a0009701302.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/94/@200/a0009701302.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/94/@200/a0009701302.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/94/@200/a0009701302.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/94/@500/a0009701302.avif',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/94/@500/a0009701302.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/94/@500/a0009701302.webp',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/94/@500/a0009701302.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/94/@500/a0009701302.jpeg',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/94/@500/a0009701302.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/94/@768/a0009701302.avif',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/94/@768/a0009701302.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/94/@768/a0009701302.webp',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/94/@768/a0009701302.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/94/@768/a0009701302.jpeg',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/94/@768/a0009701302.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/94/@1024/a0009701302.avif',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/94/@1024/a0009701302.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/94/@1024/a0009701302.webp',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/94/@1024/a0009701302.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/94/@1024/a0009701302.jpeg',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/94/@1024/a0009701302.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/94/@1366/a0009701302.avif',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/94/@1366/a0009701302.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/94/@1366/a0009701302.webp',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/94/@1366/a0009701302.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/94/@1366/a0009701302.jpeg',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/94/@1366/a0009701302.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/94/@1600/a0009701302.avif',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/94/@1600/a0009701302.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/94/@1600/a0009701302.webp',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/94/@1600/a0009701302.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/94/@1600/a0009701302.jpeg',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/94/@1600/a0009701302.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/94/@1920/a0009701302.avif',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/94/@1920/a0009701302.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/94/@1920/a0009701302.webp',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/94/@1920/a0009701302.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/94/@1920/a0009701302.jpeg',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/94/@1920/a0009701302.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/94/@3200/a0009701302.avif',
                                                                    width: 3200,
                                                                    key: 'bos-no-ecom-2/21/4/26/94/@3200/a0009701302.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/94/@3200/a0009701302.webp',
                                                                    width: 3200,
                                                                    key: 'bos-no-ecom-2/21/4/26/94/@3200/a0009701302.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/94/@3200/a0009701302.jpeg',
                                                                    width: 3200,
                                                                    key: 'bos-no-ecom-2/21/4/26/94/@3200/a0009701302.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'Barnesete Baby Safe Plus (inntil 13kg) - A0009701302',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleNumber',
                                                        content: {
                                                            text: 'A0009701302',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleName',
                                                        content: {
                                                            text: 'Barnesete',
                                                        },
                                                    },
                                                    {
                                                        id: 'brandSpecific',
                                                        content: {
                                                            value: true,
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2db671b020008b114bc',
                                                    name: 'Mercedes-Benz',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'accessoryTimeAssembly',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryIndicativePriceExcludingVatAndAssembly',
                                    content: {
                                        number: 4587,
                                    },
                                },
                                {
                                    id: 'accessoryAssemblyPriceExcludingVat',
                                    content: {
                                        number: 1200,
                                    },
                                },
                                {
                                    id: 'accessoryVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryVatEl',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatIce',
                                    content: {
                                        number: 5740,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatEl',
                                    content: {
                                        number: 5740,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatIce',
                                    content: {
                                        number: 4592,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatEl',
                                    content: {
                                        number: 4592,
                                    },
                                },
                                {
                                    id: 'accessoryRetailPriceExcludingVat',
                                    content: {
                                        number: 3899,
                                    },
                                },
                                {
                                    id: 'accessoryRetailerMargin',
                                    content: {
                                        number: 688,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'accessory',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2dc3419880008366c60',
                                                name: 'Sykkeholder A0008901800',
                                                defaultVariant: {
                                                    sku: 'A0008901800',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/178/2-sykler-a0008901700-for-3-sykler-a0008901800.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/178/2-sykler-a0008901700-for-3-sykler-a0008901800.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/178/@100/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/178/@100/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/178/@100/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/178/@100/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/178/@100/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/178/@100/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/178/@200/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/178/@200/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/178/@200/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/178/@200/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/178/@200/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/178/@200/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/178/@500/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/178/@500/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/178/@500/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/178/@500/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/178/@500/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/178/@500/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/178/@768/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/178/@768/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/178/@768/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/178/@768/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/178/@768/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/178/@768/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/178/@1024/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/178/@1024/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/178/@1024/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/178/@1024/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/178/@1024/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/178/@1024/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/178/@1366/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/178/@1366/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/178/@1366/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/178/@1366/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/178/@1366/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/178/@1366/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/178/@1600/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/178/@1600/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/178/@1600/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/178/@1600/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/178/@1600/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/178/@1600/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/178/@1920/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/178/@1920/2-sykler-a0008901700-for-3-sykler-a0008901800.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/178/@1920/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/178/@1920/2-sykler-a0008901700-for-3-sykler-a0008901800.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/178/@1920/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/178/@1920/2-sykler-a0008901700-for-3-sykler-a0008901800.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'Sykkelholder bak (3 sykler) - A0008901800',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleNumber',
                                                        content: {
                                                            text: 'A0008901800',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleName',
                                                        content: {
                                                            text: 'Sykkeholder',
                                                        },
                                                    },
                                                    {
                                                        id: 'brandSpecific',
                                                        content: {
                                                            value: true,
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2db671b020008b114bc',
                                                    name: 'Mercedes-Benz',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'accessoryTimeAssembly',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryIndicativePriceExcludingVatAndAssembly',
                                    content: {
                                        number: 9006,
                                    },
                                },
                                {
                                    id: 'accessoryAssemblyPriceExcludingVat',
                                    content: {
                                        number: 1200,
                                    },
                                },
                                {
                                    id: 'accessoryVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryVatEl',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatIce',
                                    content: {
                                        number: 11260,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatEl',
                                    content: {
                                        number: 11260,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatIce',
                                    content: {
                                        number: 9008,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatEl',
                                    content: {
                                        number: 9008,
                                    },
                                },
                                {
                                    id: 'accessoryRetailPriceExcludingVat',
                                    content: {
                                        number: 7655,
                                    },
                                },
                                {
                                    id: 'accessoryRetailerMargin',
                                    content: {
                                        number: 1351,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'accessory',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2de330a3f000a8b3a56',
                                                name: 'Skiboks SKG830T',
                                                defaultVariant: {
                                                    sku: 'SKG830T',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/172/skg830t-usikker.png',
                                                            key: 'bos-no-ecom-2/21/4/26/172/skg830t-usikker.png',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/172/@100/skg830t-usikker.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/172/@100/skg830t-usikker.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/172/@100/skg830t-usikker.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/172/@100/skg830t-usikker.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/172/@100/skg830t-usikker.png',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/172/@100/skg830t-usikker.png',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/172/@200/skg830t-usikker.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/172/@200/skg830t-usikker.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/172/@200/skg830t-usikker.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/172/@200/skg830t-usikker.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/172/@200/skg830t-usikker.png',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/172/@200/skg830t-usikker.png',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/172/@500/skg830t-usikker.avif',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/172/@500/skg830t-usikker.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/172/@500/skg830t-usikker.webp',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/172/@500/skg830t-usikker.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/172/@500/skg830t-usikker.png',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/172/@500/skg830t-usikker.png',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/172/@768/skg830t-usikker.avif',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/172/@768/skg830t-usikker.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/172/@768/skg830t-usikker.webp',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/172/@768/skg830t-usikker.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/172/@768/skg830t-usikker.png',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/172/@768/skg830t-usikker.png',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/172/@1024/skg830t-usikker.avif',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/172/@1024/skg830t-usikker.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/172/@1024/skg830t-usikker.webp',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/172/@1024/skg830t-usikker.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/172/@1024/skg830t-usikker.png',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/172/@1024/skg830t-usikker.png',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'Takboks Skiguard - SKG830T',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleNumber',
                                                        content: {
                                                            text: 'SKG830T',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleName',
                                                        content: {
                                                            text: 'Skiboks',
                                                        },
                                                    },
                                                    {
                                                        id: 'brandSpecific',
                                                        content: {
                                                            value: false,
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2db671b020008b114c1',
                                                    name: 'Skiguard',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'accessoryTimeAssembly',
                                    content: {
                                        number: 0.5,
                                    },
                                },
                                {
                                    id: 'accessoryIndicativePriceExcludingVatAndAssembly',
                                    content: {
                                        number: 9520,
                                    },
                                },
                                {
                                    id: 'accessoryAssemblyPriceExcludingVat',
                                    content: {
                                        number: 1200,
                                    },
                                },
                                {
                                    id: 'accessoryVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryVatEl',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatIce',
                                    content: {
                                        number: 12650,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatEl',
                                    content: {
                                        number: 12650,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatIce',
                                    content: {
                                        number: 10120,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatEl',
                                    content: {
                                        number: 10120,
                                    },
                                },
                                {
                                    id: 'accessoryRetailPriceExcludingVat',
                                    content: {
                                        number: 8092,
                                    },
                                },
                                {
                                    id: 'accessoryRetailerMargin',
                                    content: {
                                        number: 1428,
                                    },
                                },
                            ],
                        ],
                    },
                },
                {
                    id: 'wheels',
                    content: {
                        chunks: [
                            [
                                {
                                    id: 'wheelSet',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2d9671b020008b114ab',
                                                name: 'NOWA03623/NOWA03625',
                                                defaultVariant: {
                                                    sku: 'NOWA03623/NOWA03625',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/197/nowa03623-nowa03625.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/197/nowa03623-nowa03625.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/197/@100/nowa03623-nowa03625.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/197/@100/nowa03623-nowa03625.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/197/@100/nowa03623-nowa03625.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/197/@100/nowa03623-nowa03625.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/197/@100/nowa03623-nowa03625.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/197/@100/nowa03623-nowa03625.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/197/@200/nowa03623-nowa03625.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/197/@200/nowa03623-nowa03625.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/197/@200/nowa03623-nowa03625.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/197/@200/nowa03623-nowa03625.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/197/@200/nowa03623-nowa03625.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/197/@200/nowa03623-nowa03625.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/197/@500/nowa03623-nowa03625.avif',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/197/@500/nowa03623-nowa03625.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/197/@500/nowa03623-nowa03625.webp',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/197/@500/nowa03623-nowa03625.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/197/@500/nowa03623-nowa03625.jpeg',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/197/@500/nowa03623-nowa03625.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/197/@768/nowa03623-nowa03625.avif',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/197/@768/nowa03623-nowa03625.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/197/@768/nowa03623-nowa03625.webp',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/197/@768/nowa03623-nowa03625.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/197/@768/nowa03623-nowa03625.jpeg',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/197/@768/nowa03623-nowa03625.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/197/@1024/nowa03623-nowa03625.avif',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/197/@1024/nowa03623-nowa03625.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/197/@1024/nowa03623-nowa03625.webp',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/197/@1024/nowa03623-nowa03625.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/197/@1024/nowa03623-nowa03625.jpeg',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/197/@1024/nowa03623-nowa03625.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/197/@1366/nowa03623-nowa03625.avif',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/197/@1366/nowa03623-nowa03625.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/197/@1366/nowa03623-nowa03625.webp',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/197/@1366/nowa03623-nowa03625.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/197/@1366/nowa03623-nowa03625.jpeg',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/197/@1366/nowa03623-nowa03625.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/197/@1600/nowa03623-nowa03625.avif',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/197/@1600/nowa03623-nowa03625.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/197/@1600/nowa03623-nowa03625.webp',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/197/@1600/nowa03623-nowa03625.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/197/@1600/nowa03623-nowa03625.jpeg',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/197/@1600/nowa03623-nowa03625.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/197/@1920/nowa03623-nowa03625.avif',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/197/@1920/nowa03623-nowa03625.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/197/@1920/nowa03623-nowa03625.webp',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/197/@1920/nowa03623-nowa03625.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/197/@1920/nowa03623-nowa03625.jpeg',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/197/@1920/nowa03623-nowa03625.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/197/@3200/nowa03623-nowa03625.avif',
                                                                    width: 3200,
                                                                    key: 'bos-no-ecom-2/21/4/26/197/@3200/nowa03623-nowa03625.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/197/@3200/nowa03623-nowa03625.webp',
                                                                    width: 3200,
                                                                    key: 'bos-no-ecom-2/21/4/26/197/@3200/nowa03623-nowa03625.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/197/@3200/nowa03623-nowa03625.jpeg',
                                                                    width: 3200,
                                                                    key: 'bos-no-ecom-2/21/4/26/197/@3200/nowa03623-nowa03625.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'tireManufacturer',
                                                        content: {
                                                            text: 'Nokian',
                                                        },
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'Vinterhjul 20"',
                                                        },
                                                    },
                                                    {
                                                        id: 'nowaCodes',
                                                        content: {
                                                            chunks: [
                                                                [
                                                                    {
                                                                        id: 'code',
                                                                        content: {
                                                                            text: 'NOWA03623/NOWA03625',
                                                                        },
                                                                    },
                                                                    {
                                                                        id: 'front',
                                                                        content: {
                                                                            text: 'NOWA03623',
                                                                        },
                                                                    },
                                                                    {
                                                                        id: 'rear',
                                                                        content: {
                                                                            text: 'NOWA03625',
                                                                        },
                                                                    },
                                                                ],
                                                            ],
                                                        },
                                                    },
                                                    {
                                                        id: 'tireType',
                                                        content: {
                                                            text: 'Piggfri',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2d8330a3f000a8b3a08',
                                                    name: 'Daimler',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'isWheelSetRecommended',
                                    content: {
                                        value: true,
                                    },
                                },
                                {
                                    id: 'wheelSetVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'wheelSetVatEl',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceBeforeVat',
                                    content: {
                                        number: 35200,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceIncludingVatIce',
                                    content: {
                                        number: 44000,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceIncludingVatEl',
                                    content: {
                                        number: 35200,
                                    },
                                },
                                {
                                    id: 'wheelSetRetailerPriceExcludingVat',
                                    content: {
                                        number: 29920,
                                    },
                                },
                                {
                                    id: 'wheelSetRetailerMargin',
                                    content: {
                                        number: 5280,
                                    },
                                },
                                {
                                    id: 'wheelSetIndicativeSalesPriceExcludingVat',
                                    content: {
                                        number: 35162,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'wheelSet',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2d9330a3f000a8b3a0b',
                                                name: 'NOWA03618/NOWA03620',
                                                defaultVariant: {
                                                    sku: 'NOWA03618/NOWA03620',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/194/nowa03618-nowa03620.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/194/nowa03618-nowa03620.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/194/@100/nowa03618-nowa03620.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/194/@100/nowa03618-nowa03620.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/194/@100/nowa03618-nowa03620.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/194/@100/nowa03618-nowa03620.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/194/@100/nowa03618-nowa03620.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/194/@100/nowa03618-nowa03620.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/194/@200/nowa03618-nowa03620.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/194/@200/nowa03618-nowa03620.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/194/@200/nowa03618-nowa03620.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/194/@200/nowa03618-nowa03620.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/194/@200/nowa03618-nowa03620.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/194/@200/nowa03618-nowa03620.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/194/@500/nowa03618-nowa03620.avif',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/194/@500/nowa03618-nowa03620.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/194/@500/nowa03618-nowa03620.webp',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/194/@500/nowa03618-nowa03620.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/194/@500/nowa03618-nowa03620.jpeg',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/194/@500/nowa03618-nowa03620.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/194/@768/nowa03618-nowa03620.avif',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/194/@768/nowa03618-nowa03620.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/194/@768/nowa03618-nowa03620.webp',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/194/@768/nowa03618-nowa03620.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/194/@768/nowa03618-nowa03620.jpeg',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/194/@768/nowa03618-nowa03620.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/194/@1024/nowa03618-nowa03620.avif',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/194/@1024/nowa03618-nowa03620.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/194/@1024/nowa03618-nowa03620.webp',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/194/@1024/nowa03618-nowa03620.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/194/@1024/nowa03618-nowa03620.jpeg',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/194/@1024/nowa03618-nowa03620.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/194/@1366/nowa03618-nowa03620.avif',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/194/@1366/nowa03618-nowa03620.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/194/@1366/nowa03618-nowa03620.webp',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/194/@1366/nowa03618-nowa03620.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/194/@1366/nowa03618-nowa03620.jpeg',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/194/@1366/nowa03618-nowa03620.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/194/@1600/nowa03618-nowa03620.avif',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/194/@1600/nowa03618-nowa03620.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/194/@1600/nowa03618-nowa03620.webp',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/194/@1600/nowa03618-nowa03620.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/194/@1600/nowa03618-nowa03620.jpeg',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/194/@1600/nowa03618-nowa03620.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/194/@1920/nowa03618-nowa03620.avif',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/194/@1920/nowa03618-nowa03620.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/194/@1920/nowa03618-nowa03620.webp',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/194/@1920/nowa03618-nowa03620.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/194/@1920/nowa03618-nowa03620.jpeg',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/194/@1920/nowa03618-nowa03620.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/194/@3200/nowa03618-nowa03620.avif',
                                                                    width: 3200,
                                                                    key: 'bos-no-ecom-2/21/4/26/194/@3200/nowa03618-nowa03620.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/194/@3200/nowa03618-nowa03620.webp',
                                                                    width: 3200,
                                                                    key: 'bos-no-ecom-2/21/4/26/194/@3200/nowa03618-nowa03620.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/194/@3200/nowa03618-nowa03620.jpeg',
                                                                    width: 3200,
                                                                    key: 'bos-no-ecom-2/21/4/26/194/@3200/nowa03618-nowa03620.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'tireManufacturer',
                                                        content: {
                                                            text: 'Nokian',
                                                        },
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'Vinterhjul 19"',
                                                        },
                                                    },
                                                    {
                                                        id: 'nowaCodes',
                                                        content: {
                                                            chunks: [
                                                                [
                                                                    {
                                                                        id: 'code',
                                                                        content: {
                                                                            text: 'NOWA03618/NOWA03620',
                                                                        },
                                                                    },
                                                                    {
                                                                        id: 'front',
                                                                        content: {
                                                                            text: 'NOWA03618',
                                                                        },
                                                                    },
                                                                    {
                                                                        id: 'rear',
                                                                        content: {
                                                                            text: 'NOWA03620',
                                                                        },
                                                                    },
                                                                ],
                                                            ],
                                                        },
                                                    },
                                                    {
                                                        id: 'tireType',
                                                        content: {
                                                            text: 'Pigg',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2d8330a3f000a8b3a08',
                                                    name: 'Daimler',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'isWheelSetRecommended',
                                    content: {
                                        value: false,
                                    },
                                },
                                {
                                    id: 'wheelSetVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'wheelSetVatEl',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceBeforeVat',
                                    content: {
                                        number: 32900,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceIncludingVatIce',
                                    content: {
                                        number: 41125,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceIncludingVatEl',
                                    content: {
                                        number: 32900,
                                    },
                                },
                                {
                                    id: 'wheelSetRetailerPriceExcludingVat',
                                    content: {
                                        number: 27965,
                                    },
                                },
                                {
                                    id: 'wheelSetRetailerMargin',
                                    content: {
                                        number: 4935,
                                    },
                                },
                                {
                                    id: 'wheelSetIndicativeSalesPriceExcludingVat',
                                    content: {
                                        number: 32890,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'wheelSet',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2d9330a3f000a8b3a0e',
                                                name: 'NOWA03619/NOWA03621',
                                                defaultVariant: {
                                                    sku: 'NOWA03619/NOWA03621',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/199/nowa03619-nowa03621.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/199/nowa03619-nowa03621.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/199/@100/nowa03619-nowa03621.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/199/@100/nowa03619-nowa03621.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/199/@100/nowa03619-nowa03621.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/199/@100/nowa03619-nowa03621.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/199/@100/nowa03619-nowa03621.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/199/@100/nowa03619-nowa03621.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/199/@200/nowa03619-nowa03621.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/199/@200/nowa03619-nowa03621.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/199/@200/nowa03619-nowa03621.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/199/@200/nowa03619-nowa03621.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/199/@200/nowa03619-nowa03621.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/199/@200/nowa03619-nowa03621.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/199/@500/nowa03619-nowa03621.avif',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/199/@500/nowa03619-nowa03621.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/199/@500/nowa03619-nowa03621.webp',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/199/@500/nowa03619-nowa03621.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/199/@500/nowa03619-nowa03621.jpeg',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/199/@500/nowa03619-nowa03621.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/199/@768/nowa03619-nowa03621.avif',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/199/@768/nowa03619-nowa03621.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/199/@768/nowa03619-nowa03621.webp',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/199/@768/nowa03619-nowa03621.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/199/@768/nowa03619-nowa03621.jpeg',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/199/@768/nowa03619-nowa03621.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/199/@1024/nowa03619-nowa03621.avif',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/199/@1024/nowa03619-nowa03621.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/199/@1024/nowa03619-nowa03621.webp',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/199/@1024/nowa03619-nowa03621.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/199/@1024/nowa03619-nowa03621.jpeg',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/199/@1024/nowa03619-nowa03621.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/199/@1366/nowa03619-nowa03621.avif',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/199/@1366/nowa03619-nowa03621.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/199/@1366/nowa03619-nowa03621.webp',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/199/@1366/nowa03619-nowa03621.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/199/@1366/nowa03619-nowa03621.jpeg',
                                                                    width: 1366,
                                                                    key: 'bos-no-ecom-2/21/4/26/199/@1366/nowa03619-nowa03621.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/199/@1600/nowa03619-nowa03621.avif',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/199/@1600/nowa03619-nowa03621.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/199/@1600/nowa03619-nowa03621.webp',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/199/@1600/nowa03619-nowa03621.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/199/@1600/nowa03619-nowa03621.jpeg',
                                                                    width: 1600,
                                                                    key: 'bos-no-ecom-2/21/4/26/199/@1600/nowa03619-nowa03621.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/199/@1920/nowa03619-nowa03621.avif',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/199/@1920/nowa03619-nowa03621.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/199/@1920/nowa03619-nowa03621.webp',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/199/@1920/nowa03619-nowa03621.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/199/@1920/nowa03619-nowa03621.jpeg',
                                                                    width: 1920,
                                                                    key: 'bos-no-ecom-2/21/4/26/199/@1920/nowa03619-nowa03621.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/199/@3200/nowa03619-nowa03621.avif',
                                                                    width: 3200,
                                                                    key: 'bos-no-ecom-2/21/4/26/199/@3200/nowa03619-nowa03621.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/199/@3200/nowa03619-nowa03621.webp',
                                                                    width: 3200,
                                                                    key: 'bos-no-ecom-2/21/4/26/199/@3200/nowa03619-nowa03621.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/199/@3200/nowa03619-nowa03621.jpeg',
                                                                    width: 3200,
                                                                    key: 'bos-no-ecom-2/21/4/26/199/@3200/nowa03619-nowa03621.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'tireManufacturer',
                                                        content: {
                                                            text: 'Nokian',
                                                        },
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'Vinterhjul 19"',
                                                        },
                                                    },
                                                    {
                                                        id: 'nowaCodes',
                                                        content: {
                                                            chunks: [
                                                                [
                                                                    {
                                                                        id: 'code',
                                                                        content: {
                                                                            text: 'NOWA03619/NOWA03621',
                                                                        },
                                                                    },
                                                                    {
                                                                        id: 'front',
                                                                        content: {
                                                                            text: 'NOWA03619',
                                                                        },
                                                                    },
                                                                    {
                                                                        id: 'rear',
                                                                        content: {
                                                                            text: 'NOWA03621',
                                                                        },
                                                                    },
                                                                ],
                                                            ],
                                                        },
                                                    },
                                                    {
                                                        id: 'tireType',
                                                        content: {
                                                            text: 'Piggfri',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2d8330a3f000a8b3a08',
                                                    name: 'Daimler',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'isWheelSetRecommended',
                                    content: {
                                        value: false,
                                    },
                                },
                                {
                                    id: 'wheelSetVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'wheelSetVatEl',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceBeforeVat',
                                    content: {
                                        number: 32400,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceIncludingVatIce',
                                    content: {
                                        number: 40500,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceIncludingVatEl',
                                    content: {
                                        number: 32400,
                                    },
                                },
                                {
                                    id: 'wheelSetRetailerPriceExcludingVat',
                                    content: {
                                        number: 27540,
                                    },
                                },
                                {
                                    id: 'wheelSetRetailerMargin',
                                    content: {
                                        number: 4860,
                                    },
                                },
                                {
                                    id: 'wheelSetIndicativeSalesPriceExcludingVat',
                                    content: {
                                        number: 32331,
                                    },
                                },
                            ],
                        ],
                    },
                },
                {
                    id: 'interiors',
                    content: {
                        chunks: [],
                    },
                },
            ],
            model: {
                id: '608fe2c1671b020008b1130b',
                name: 'EQC400 4M',
                components: [
                    {
                        id: 'manufacturer',
                        content: null,
                    },
                    {
                        id: 'marketing',
                        content: null,
                    },
                    {
                        id: 'availableOnBos',
                        content: {
                            value: false,
                        },
                    },
                    {
                        id: 'availableOnNext',
                        content: {
                            value: true,
                        },
                    },
                    {
                        id: 'quoteText',
                        content: {
                            plainText: [''],
                        },
                    },
                    {
                        id: 'campaignText',
                        content: null,
                    },
                    {
                        id: 'carType',
                        content: {
                            text: 'EL',
                        },
                    },
                    {
                        id: 'allRelatedTrim',
                        content: null,
                    },
                    {
                        id: 'sellableTrimsOnBos',
                        content: null,
                    },
                    {
                        id: 'productCardFeaturedTrim',
                        content: null,
                    },
                    {
                        id: 'properties',
                        content: {
                            sections: [
                                {
                                    title: 'Car',
                                    properties: [
                                        {
                                            key: 'bodyType',
                                            value: 'SUV',
                                        },
                                        {
                                            key: 'luggageVolume',
                                            value: '500',
                                        },
                                        {
                                            key: 'numberOfSeats',
                                            value: '5',
                                        },
                                        {
                                            key: 'modelYear',
                                            value: '2021',
                                        },
                                        {
                                            key: 'towingCapacity',
                                            value: '1800 kg',
                                        },
                                        {
                                            key: 'roofCapacity',
                                            value: '75 kg',
                                        },
                                    ],
                                },
                                {
                                    title: 'Motor',
                                    properties: [
                                        {
                                            key: 'fuel',
                                            value: 'Elektrisk',
                                        },
                                        {
                                            key: 'powertrain',
                                            value: 'Firehjulsdrift',
                                        },
                                        {
                                            key: 'transmission',
                                            value: 'Automat',
                                        },
                                        {
                                            key: 'consumption',
                                            value: '232,0- 205,0 Wh/km',
                                        },
                                        {
                                            key: 'effect',
                                            value: '408 hk',
                                        },
                                    ],
                                },
                                {
                                    title: 'Electric',
                                    properties: [
                                        {
                                            key: 'electricRange',
                                            value: '417 km',
                                        },
                                        {
                                            key: 'batteryCapacity',
                                            value: '85 kWh',
                                        },
                                        {
                                            key: 'chargingCapacityAC',
                                            value: '7,4 kW',
                                        },
                                        {
                                            key: 'chargingCapacityDC',
                                            value: '110 kW',
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                ],
                modelSeries: {
                    id: '60cc62095e0939000944f5a6',
                    name: 'EQC',
                    components: [],
                    manufacturer: {
                        id: '608fe2c1671b020008b11307',
                        name: 'Mercedes-Benz',
                        components: [
                            {
                                id: 'logo',
                                content: {},
                            },
                            {
                                id: 'description',
                                content: {
                                    plainText: [
                                        'Med en bil fra Mercedes-Benz kan du forvente luksus, sportslighet og ytelse. Bilene er svært populære og ansett for å være blant verdens beste. I 2018 var Mercedes-Benz det mest solgte premium bilmerket i verden med 2,3 millioner solgte personbiler.',
                                    ],
                                },
                            },
                        ],
                    },
                },
            },
        },
        salesPackage1: {
            id: '608fe2e5671b020008b1152c',
            name: 'e208 Allure',
            defaultVariant: {
                sku: 'P21ALLEV D0QU',
                priceVariants: [
                    {
                        identifier: 'default',
                        price: 303021,
                    },
                ],
                images: [
                    {
                        url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/utvendig-1.jpg',
                        key: 'bos-no-ecom-2/21/4/26/71/utvendig-1.jpg',
                        variants: [
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@100/utvendig-1.avif',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/71/@100/utvendig-1.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@100/utvendig-1.webp',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/71/@100/utvendig-1.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@100/utvendig-1.jpeg',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/71/@100/utvendig-1.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@200/utvendig-1.avif',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/71/@200/utvendig-1.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@200/utvendig-1.webp',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/71/@200/utvendig-1.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@200/utvendig-1.jpeg',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/71/@200/utvendig-1.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@500/utvendig-1.avif',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/71/@500/utvendig-1.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@500/utvendig-1.webp',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/71/@500/utvendig-1.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@500/utvendig-1.jpeg',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/71/@500/utvendig-1.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@768/utvendig-1.avif',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/71/@768/utvendig-1.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@768/utvendig-1.webp',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/71/@768/utvendig-1.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@768/utvendig-1.jpeg',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/71/@768/utvendig-1.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@1024/utvendig-1.avif',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/71/@1024/utvendig-1.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@1024/utvendig-1.webp',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/71/@1024/utvendig-1.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@1024/utvendig-1.jpeg',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/71/@1024/utvendig-1.jpeg',
                            },
                        ],
                    },
                    {
                        url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/utvendig-2.jpg',
                        key: 'bos-no-ecom-2/21/4/26/71/utvendig-2.jpg',
                        variants: [
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@100/utvendig-2.avif',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/71/@100/utvendig-2.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@100/utvendig-2.webp',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/71/@100/utvendig-2.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@100/utvendig-2.jpeg',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/71/@100/utvendig-2.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@200/utvendig-2.avif',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/71/@200/utvendig-2.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@200/utvendig-2.webp',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/71/@200/utvendig-2.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@200/utvendig-2.jpeg',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/71/@200/utvendig-2.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@500/utvendig-2.avif',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/71/@500/utvendig-2.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@500/utvendig-2.webp',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/71/@500/utvendig-2.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@500/utvendig-2.jpeg',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/71/@500/utvendig-2.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@768/utvendig-2.avif',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/71/@768/utvendig-2.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@768/utvendig-2.webp',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/71/@768/utvendig-2.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@768/utvendig-2.jpeg',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/71/@768/utvendig-2.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@1024/utvendig-2.avif',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/71/@1024/utvendig-2.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@1024/utvendig-2.webp',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/71/@1024/utvendig-2.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@1024/utvendig-2.jpeg',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/71/@1024/utvendig-2.jpeg',
                            },
                        ],
                    },
                    {
                        url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/side.jpg',
                        key: 'bos-no-ecom-2/21/4/26/71/side.jpg',
                        variants: [
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@100/side.avif',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/71/@100/side.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@100/side.webp',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/71/@100/side.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@100/side.jpeg',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/71/@100/side.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@200/side.avif',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/71/@200/side.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@200/side.webp',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/71/@200/side.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@200/side.jpeg',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/71/@200/side.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@500/side.avif',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/71/@500/side.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@500/side.webp',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/71/@500/side.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@500/side.jpeg',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/71/@500/side.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@768/side.avif',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/71/@768/side.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@768/side.webp',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/71/@768/side.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@768/side.jpeg',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/71/@768/side.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@1024/side.avif',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/71/@1024/side.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@1024/side.webp',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/71/@1024/side.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@1024/side.jpeg',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/71/@1024/side.jpeg',
                            },
                        ],
                    },
                    {
                        url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/ny1.jpg',
                        key: 'bos-no-ecom-2/21/4/26/71/ny1.jpg',
                        variants: [
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@100/ny1.avif',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/71/@100/ny1.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@100/ny1.webp',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/71/@100/ny1.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@100/ny1.jpeg',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/71/@100/ny1.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@200/ny1.avif',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/71/@200/ny1.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@200/ny1.webp',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/71/@200/ny1.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@200/ny1.jpeg',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/71/@200/ny1.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@500/ny1.avif',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/71/@500/ny1.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@500/ny1.webp',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/71/@500/ny1.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@500/ny1.jpeg',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/71/@500/ny1.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@768/ny1.avif',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/71/@768/ny1.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@768/ny1.webp',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/71/@768/ny1.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@768/ny1.jpeg',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/71/@768/ny1.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@1024/ny1.avif',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/71/@1024/ny1.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@1024/ny1.webp',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/71/@1024/ny1.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@1024/ny1.jpeg',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/71/@1024/ny1.jpeg',
                            },
                        ],
                    },
                    {
                        url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/innvendig.jpg',
                        key: 'bos-no-ecom-2/21/4/26/71/innvendig.jpg',
                        variants: [
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@100/innvendig.avif',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/71/@100/innvendig.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@100/innvendig.webp',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/71/@100/innvendig.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@100/innvendig.jpeg',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/71/@100/innvendig.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@200/innvendig.avif',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/71/@200/innvendig.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@200/innvendig.webp',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/71/@200/innvendig.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@200/innvendig.jpeg',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/71/@200/innvendig.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@500/innvendig.avif',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/71/@500/innvendig.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@500/innvendig.webp',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/71/@500/innvendig.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@500/innvendig.jpeg',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/71/@500/innvendig.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@768/innvendig.avif',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/71/@768/innvendig.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@768/innvendig.webp',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/71/@768/innvendig.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@768/innvendig.jpeg',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/71/@768/innvendig.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@1024/innvendig.avif',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/71/@1024/innvendig.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@1024/innvendig.webp',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/71/@1024/innvendig.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@1024/innvendig.jpeg',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/71/@1024/innvendig.jpeg',
                            },
                        ],
                    },
                    {
                        url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/ny2.jpg',
                        key: 'bos-no-ecom-2/21/4/26/71/ny2.jpg',
                        variants: [
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@100/ny2.avif',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/71/@100/ny2.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@100/ny2.webp',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/71/@100/ny2.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@100/ny2.jpeg',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/71/@100/ny2.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@200/ny2.avif',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/71/@200/ny2.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@200/ny2.webp',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/71/@200/ny2.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@200/ny2.jpeg',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/71/@200/ny2.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@500/ny2.avif',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/71/@500/ny2.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@500/ny2.webp',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/71/@500/ny2.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@500/ny2.jpeg',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/71/@500/ny2.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@768/ny2.avif',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/71/@768/ny2.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@768/ny2.webp',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/71/@768/ny2.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@768/ny2.jpeg',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/71/@768/ny2.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@1024/ny2.avif',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/71/@1024/ny2.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@1024/ny2.webp',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/71/@1024/ny2.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/71/@1024/ny2.jpeg',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/71/@1024/ny2.jpeg',
                            },
                        ],
                    },
                    {
                        url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/ny1.jpg',
                        key: 'bos-no-ecom-2/21/4/26/14/ny1.jpg',
                        variants: [
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@100/ny1.avif',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/14/@100/ny1.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@100/ny1.webp',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/14/@100/ny1.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@100/ny1.jpeg',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/14/@100/ny1.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@200/ny1.avif',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/14/@200/ny1.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@200/ny1.webp',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/14/@200/ny1.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@200/ny1.jpeg',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/14/@200/ny1.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@500/ny1.avif',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/14/@500/ny1.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@500/ny1.webp',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/14/@500/ny1.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@500/ny1.jpeg',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/14/@500/ny1.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@768/ny1.avif',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/14/@768/ny1.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@768/ny1.webp',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/14/@768/ny1.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@768/ny1.jpeg',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/14/@768/ny1.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@1024/ny1.avif',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/14/@1024/ny1.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@1024/ny1.webp',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/14/@1024/ny1.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@1024/ny1.jpeg',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/14/@1024/ny1.jpeg',
                            },
                        ],
                    },
                    {
                        url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/ny2.jpg',
                        key: 'bos-no-ecom-2/21/4/26/14/ny2.jpg',
                        variants: [
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@100/ny2.avif',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/14/@100/ny2.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@100/ny2.webp',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/14/@100/ny2.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@100/ny2.jpeg',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/14/@100/ny2.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@200/ny2.avif',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/14/@200/ny2.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@200/ny2.webp',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/14/@200/ny2.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@200/ny2.jpeg',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/14/@200/ny2.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@500/ny2.avif',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/14/@500/ny2.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@500/ny2.webp',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/14/@500/ny2.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@500/ny2.jpeg',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/14/@500/ny2.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@768/ny2.avif',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/14/@768/ny2.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@768/ny2.webp',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/14/@768/ny2.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@768/ny2.jpeg',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/14/@768/ny2.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@1024/ny2.avif',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/14/@1024/ny2.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@1024/ny2.webp',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/14/@1024/ny2.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/14/@1024/ny2.jpeg',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/14/@1024/ny2.jpeg',
                            },
                        ],
                    },
                ],
            },
            components: [
                {
                    id: 'modelSeries',
                    content: null,
                },
                {
                    id: 'campaignText',
                    content: null,
                },
                {
                    id: 'seriesBrand',
                    content: {
                        text: 'P21ALLEV',
                    },
                },
                {
                    id: 'salesArticle',
                    content: {
                        text: 'e208 Allure 136hk',
                    },
                },
                {
                    id: 'salesPackage',
                    content: {
                        text: 'Allure',
                    },
                },
                {
                    id: 'quoteText',
                    content: {
                        plainText: [''],
                    },
                },
                {
                    id: 'standardInteriorCode',
                    content: {
                        text: 'A6FX',
                    },
                },
                {
                    id: 'standardRimCode',
                    content: null,
                },
                {
                    id: 'uniqueBrandIdentifier',
                    content: {
                        text: 'D0QU',
                    },
                },
                {
                    id: 'standardEquipment',
                    content: {
                        chunks: [
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'AC 7,4 kW normalladeinntak enfas',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'DC hurtiglading på inntil 100 kW',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Varmepumpe',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Aktiv kjøling av batteri',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Programmerbar lading',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Varme/kjøling via App',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Keyless start',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Active Safety Brake',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Skiltgjenkjenning',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Avstands- og filskiftevarsling',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Eco LED frontlys',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Automatisk klimaanlegg',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'DAB+',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Mirror Screen',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'ryggesensor',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Elektrisk innfellbare sidespeil',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Regnsensor',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Cruisekontroll',
                                    },
                                },
                            ],
                        ],
                    },
                },
                {
                    id: 'packageEquipment',
                    content: {
                        chunks: [
                            [
                                {
                                    id: 'packageEquipmentName',
                                    content: {
                                        text: 'Lite sportsratt med head-up instrumenter',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'packageEquipmentName',
                                    content: {
                                        text: "3D 10'' instrumentpanel",
                                    },
                                },
                            ],
                        ],
                    },
                },
                {
                    id: 'equipmentHighlights',
                    content: {
                        chunks: [
                            [
                                {
                                    id: 'equipmentHighlightName',
                                    content: {
                                        text: "16'' sommerhjul",
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'equipmentHighlightName',
                                    content: {
                                        text: '180 graders ryggekamera',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'equipmentHighlightName',
                                    content: {
                                        text: "7'' berøringskjerm",
                                    },
                                },
                            ],
                        ],
                    },
                },
                {
                    id: 'prices',
                    content: {
                        chunks: [
                            [
                                {
                                    id: 'netCustomerPriceIncludingVat',
                                    content: {
                                        number: 303020,
                                    },
                                },
                                {
                                    id: 'leasingBasisPrice',
                                    content: {
                                        number: 303020,
                                    },
                                },
                                {
                                    id: 'listPriceCar',
                                    content: {
                                        number: 279900,
                                    },
                                },
                                {
                                    id: 'listPricePackageCodes',
                                    content: {
                                        number: 2320,
                                    },
                                },
                                {
                                    id: 'importerSupportExcludingMva',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'leasingExtraCustomerAdvantage',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'packageDiscountWinterWheelsIncludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'customerAdvantageCarIncludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'deliveryCharge',
                                    content: {
                                        number: 8000,
                                    },
                                },
                                {
                                    id: 'vatCode',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'vehicleRoadTax',
                                    content: {
                                        number: 2400,
                                    },
                                },
                                {
                                    id: 'grossCustomerPriceExcluding',
                                    content: {
                                        number: 282220,
                                    },
                                },
                                {
                                    id: 'indicativePriceExcludingVat',
                                    content: {
                                        number: 279820,
                                    },
                                },
                                {
                                    id: 'retailerSupportExcludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'totalCustomerAdvantageIncludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'totalCustomerAdvantageExcludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'winterTiresWithMarkedPack',
                                    content: {
                                        number: 12800,
                                    },
                                },
                                {
                                    id: 'wreckage',
                                    content: {
                                        number: 2400,
                                    },
                                },
                                {
                                    id: 'dealerMarginCar',
                                    content: {
                                        number: 8,
                                    },
                                },
                                {
                                    id: 'dealerMarginPackageCodes',
                                    content: {
                                        number: 14,
                                    },
                                },
                                {
                                    id: 'retailerBasicMargin',
                                    content: {
                                        number: 22525,
                                    },
                                },
                                {
                                    id: 'retailerCampaignMarginLeasing',
                                    content: {
                                        number: 22525,
                                    },
                                },
                                {
                                    id: 'retailerCampaignMarginSale',
                                    content: {
                                        number: 22525,
                                    },
                                },
                                {
                                    id: 'residualValue3y30',
                                    content: {
                                        number: 163352,
                                    },
                                },
                                {
                                    id: 'residualValue3y45',
                                    content: {
                                        number: 157624,
                                    },
                                },
                                {
                                    id: 'residualValue3y60',
                                    content: {
                                        number: 149065,
                                    },
                                },
                                {
                                    id: 'residualValue4y40',
                                    content: {
                                        number: 140500,
                                    },
                                },
                                {
                                    id: 'residualValue4y60',
                                    content: {
                                        number: 132000,
                                    },
                                },
                                {
                                    id: 'leasingDepositExcludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'oneTimeLeasingFeeIncludingVat',
                                    content: {
                                        number: 4250,
                                    },
                                },
                                {
                                    id: 'oneTimeLoanFee',
                                    content: {
                                        number: 4250,
                                    },
                                },
                                {
                                    id: 'invoiceFeeLeasingIncludingVat',
                                    content: {
                                        number: 85,
                                    },
                                },
                                {
                                    id: 'invoiceFeeLoan',
                                    content: {
                                        number: 85,
                                    },
                                },
                                {
                                    id: 'leasingRate',
                                    content: {
                                        number: 1.99,
                                    },
                                },
                                {
                                    id: 'loanRate',
                                    content: {
                                        number: 3.8,
                                    },
                                },
                                {
                                    id: 'leasingDepositIncludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'leasingDepositIncludingVatAndOneTimeFee',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'calculationBaseLeasing',
                                    content: {
                                        number: 303020,
                                    },
                                },
                                {
                                    id: 'monthlyLeasing3y30',
                                    content: {
                                        number: 4349,
                                    },
                                },
                                {
                                    id: 'totalLeasing3y30',
                                    content: {
                                        number: 160802,
                                    },
                                },
                                {
                                    id: 'monthlyLeasing3y45',
                                    content: {
                                        number: 4503,
                                    },
                                },
                                {
                                    id: 'totalLeasing3y45',
                                    content: {
                                        number: 166356,
                                    },
                                },
                                {
                                    id: 'monthlyLeasing4y40',
                                    content: {
                                        number: 3837,
                                    },
                                },
                                {
                                    id: 'totalLeasing4y40',
                                    content: {
                                        number: 188424,
                                    },
                                },
                                {
                                    id: 'monthlyLoan5y35Equity',
                                    content: {
                                        number: 3773,
                                    },
                                },
                                {
                                    id: 'totalLoanCost5y35Equity',
                                    content: {
                                        number: 332408,
                                    },
                                },
                                {
                                    id: 'shortLegalTextLeasing3y30',
                                    content: {
                                        plainText: ['Startleie 0 kr / 36 mnd / 30 000 km / Nom. Rente 1.99%'],
                                    },
                                },
                                {
                                    id: 'longLegalTextLeasing3y30',
                                    content: null,
                                },
                                {
                                    id: 'shortLegalTextLeasing3y45',
                                    content: {
                                        plainText: ['Startleie 0 kr / 36 mnd / 45 000 km / Nom. Rente 1.99%'],
                                    },
                                },
                                {
                                    id: 'longLegalTextLeasing3y45',
                                    content: null,
                                },
                                {
                                    id: 'shortLegalTextLeasing4y40',
                                    content: {
                                        plainText: ['Startleie 0 kr / 48 mnd / 40 000 km / Nom. Rente 1.99%'],
                                    },
                                },
                                {
                                    id: 'longLegalTextLeasing4y40',
                                    content: null,
                                },
                                {
                                    id: 'shortLegalTextLoan',
                                    content: {
                                        plainText: ['35 % Egenkapital / 5 År / Nom. rente 3.,8%'],
                                    },
                                },
                                {
                                    id: 'longLegalTextLoan',
                                    content: null,
                                },
                            ],
                        ],
                    },
                },
                {
                    id: 'varnishes',
                    content: null,
                },
                {
                    id: 'accessories',
                    content: {
                        chunks: [
                            [
                                {
                                    id: 'accessory',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2de671b020008b114eb',
                                                name: 'Skvettlapper 1635053880',
                                                defaultVariant: {
                                                    sku: '1635053880',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/121/1635053880.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/121/1635053880.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/121/@100/1635053880.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/121/@100/1635053880.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/121/@100/1635053880.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/121/@100/1635053880.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/121/@100/1635053880.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/121/@100/1635053880.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/121/@200/1635053880.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/121/@200/1635053880.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/121/@200/1635053880.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/121/@200/1635053880.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/121/@200/1635053880.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/121/@200/1635053880.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'Skvettlapper bak  for biler med skjermutvidere - 1635053880',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleNumber',
                                                        content: {
                                                            text: '1635053880',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleName',
                                                        content: {
                                                            text: 'Skvettlapper',
                                                        },
                                                    },
                                                    {
                                                        id: 'brandSpecific',
                                                        content: {
                                                            value: true,
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2db671b020008b114c0',
                                                    name: 'Peugeot',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'accessoryTimeAssembly',
                                    content: {
                                        number: 0.6,
                                    },
                                },
                                {
                                    id: 'accessoryIndicativePriceExcludingVatAndAssembly',
                                    content: {
                                        number: 553,
                                    },
                                },
                                {
                                    id: 'accessoryAssemblyPriceExcludingVat',
                                    content: {
                                        number: 1120,
                                    },
                                },
                                {
                                    id: 'accessoryVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryVatEl',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatIce',
                                    content: {
                                        number: 1540,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatEl',
                                    content: {
                                        number: 1540,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatIce',
                                    content: {
                                        number: 1232,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatEl',
                                    content: {
                                        number: 1232,
                                    },
                                },
                                {
                                    id: 'accessoryRetailPriceExcludingVat',
                                    content: {
                                        number: 470,
                                    },
                                },
                                {
                                    id: 'accessoryRetailerMargin',
                                    content: {
                                        number: 83,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'accessory',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2de671b020008b114e9',
                                                name: 'Skvettlapper 1635053680',
                                                defaultVariant: {
                                                    sku: '1635053680',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/133/1635053680.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/133/1635053680.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/133/@100/1635053680.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/133/@100/1635053680.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/133/@100/1635053680.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/133/@100/1635053680.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/133/@100/1635053680.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/133/@100/1635053680.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/133/@200/1635053680.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/133/@200/1635053680.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/133/@200/1635053680.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/133/@200/1635053680.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/133/@200/1635053680.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/133/@200/1635053680.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'Skvettlapper foran for biler med skjermutvidere - 1635053680',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleNumber',
                                                        content: {
                                                            text: '1635053680',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleName',
                                                        content: {
                                                            text: 'Skvettlapper',
                                                        },
                                                    },
                                                    {
                                                        id: 'brandSpecific',
                                                        content: {
                                                            value: true,
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2db671b020008b114c0',
                                                    name: 'Peugeot',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'accessoryTimeAssembly',
                                    content: {
                                        number: 0.6,
                                    },
                                },
                                {
                                    id: 'accessoryIndicativePriceExcludingVatAndAssembly',
                                    content: {
                                        number: 553,
                                    },
                                },
                                {
                                    id: 'accessoryAssemblyPriceExcludingVat',
                                    content: {
                                        number: 1120,
                                    },
                                },
                                {
                                    id: 'accessoryVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryVatEl',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatIce',
                                    content: {
                                        number: 1540,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatEl',
                                    content: {
                                        number: 1540,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatIce',
                                    content: {
                                        number: 1232,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatEl',
                                    content: {
                                        number: 1232,
                                    },
                                },
                                {
                                    id: 'accessoryRetailPriceExcludingVat',
                                    content: {
                                        number: 470,
                                    },
                                },
                                {
                                    id: 'accessoryRetailerMargin',
                                    content: {
                                        number: 83,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'accessory',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2df330a3f000a8b3a6b',
                                                name: 'Vindavviser 1648389080',
                                                defaultVariant: {
                                                    sku: '1648389080',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/138/1648389080.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/138/1648389080.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/138/@100/1648389080.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/138/@100/1648389080.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/138/@100/1648389080.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/138/@100/1648389080.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/138/@100/1648389080.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/138/@100/1648389080.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/138/@200/1648389080.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/138/@200/1648389080.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/138/@200/1648389080.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/138/@200/1648389080.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/138/@200/1648389080.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/138/@200/1648389080.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/138/@500/1648389080.avif',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/138/@500/1648389080.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/138/@500/1648389080.webp',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/138/@500/1648389080.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/138/@500/1648389080.jpeg',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/138/@500/1648389080.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/138/@768/1648389080.avif',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/138/@768/1648389080.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/138/@768/1648389080.webp',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/138/@768/1648389080.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/138/@768/1648389080.jpeg',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/138/@768/1648389080.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/138/@1024/1648389080.avif',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/138/@1024/1648389080.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/138/@1024/1648389080.webp',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/138/@1024/1648389080.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/138/@1024/1648389080.jpeg',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/138/@1024/1648389080.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'Vindavviser sett  fordører   - 1648389080',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleNumber',
                                                        content: {
                                                            text: '1648389080',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleName',
                                                        content: {
                                                            text: 'Vindavviser',
                                                        },
                                                    },
                                                    {
                                                        id: 'brandSpecific',
                                                        content: {
                                                            value: true,
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2db671b020008b114c0',
                                                    name: 'Peugeot',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'accessoryTimeAssembly',
                                    content: {
                                        number: 0.2,
                                    },
                                },
                                {
                                    id: 'accessoryIndicativePriceExcludingVatAndAssembly',
                                    content: {
                                        number: 775,
                                    },
                                },
                                {
                                    id: 'accessoryAssemblyPriceExcludingVat',
                                    content: {
                                        number: 1120,
                                    },
                                },
                                {
                                    id: 'accessoryVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryVatEl',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatIce',
                                    content: {
                                        number: 1250,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatEl',
                                    content: {
                                        number: 1250,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatIce',
                                    content: {
                                        number: 1000,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatEl',
                                    content: {
                                        number: 1000,
                                    },
                                },
                                {
                                    id: 'accessoryRetailPriceExcludingVat',
                                    content: {
                                        number: 658,
                                    },
                                },
                                {
                                    id: 'accessoryRetailerMargin',
                                    content: {
                                        number: 116,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'accessory',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2df671b020008b114f6',
                                                name: 'Bagasjeromsmatte 1648406680',
                                                defaultVariant: {
                                                    sku: '1648406680',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/149/1648406680.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/149/1648406680.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/149/@100/1648406680.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/149/@100/1648406680.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/149/@100/1648406680.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/149/@100/1648406680.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/149/@100/1648406680.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/149/@100/1648406680.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/149/@200/1648406680.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/149/@200/1648406680.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/149/@200/1648406680.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/149/@200/1648406680.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/149/@200/1648406680.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/149/@200/1648406680.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/149/@500/1648406680.avif',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/149/@500/1648406680.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/149/@500/1648406680.webp',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/149/@500/1648406680.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/149/@500/1648406680.jpeg',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/149/@500/1648406680.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/149/@768/1648406680.avif',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/149/@768/1648406680.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/149/@768/1648406680.webp',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/149/@768/1648406680.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/149/@768/1648406680.jpeg',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/149/@768/1648406680.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/149/@1024/1648406680.avif',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/149/@1024/1648406680.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/149/@1024/1648406680.webp',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/149/@1024/1648406680.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/149/@1024/1648406680.jpeg',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/149/@1024/1648406680.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'Bagasjeromsmatte  - 1648406680',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleNumber',
                                                        content: {
                                                            text: '1648406680',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleName',
                                                        content: {
                                                            text: 'Bagasjeromsmatte',
                                                        },
                                                    },
                                                    {
                                                        id: 'brandSpecific',
                                                        content: {
                                                            value: true,
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2db671b020008b114c0',
                                                    name: 'Peugeot',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'accessoryTimeAssembly',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryIndicativePriceExcludingVatAndAssembly',
                                    content: {
                                        number: 652,
                                    },
                                },
                                {
                                    id: 'accessoryAssemblyPriceExcludingVat',
                                    content: {
                                        number: 1120,
                                    },
                                },
                                {
                                    id: 'accessoryVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryVatEl',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatIce',
                                    content: {
                                        number: 820,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatEl',
                                    content: {
                                        number: 660,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatIce',
                                    content: {
                                        number: 656,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatEl',
                                    content: {
                                        number: 660,
                                    },
                                },
                                {
                                    id: 'accessoryRetailPriceExcludingVat',
                                    content: {
                                        number: 554,
                                    },
                                },
                                {
                                    id: 'accessoryRetailerMargin',
                                    content: {
                                        number: 98,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'accessory',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2df330a3f000a8b3a6e',
                                                name: 'Oppbevaringsbag 9837945080',
                                                defaultVariant: {
                                                    sku: '9837945080',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/136/9837945080.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/136/9837945080.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/136/@100/9837945080.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/136/@100/9837945080.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/136/@100/9837945080.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/136/@100/9837945080.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/136/@100/9837945080.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/136/@100/9837945080.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/136/@200/9837945080.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/136/@200/9837945080.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/136/@200/9837945080.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/136/@200/9837945080.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/136/@200/9837945080.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/136/@200/9837945080.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/136/@500/9837945080.avif',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/136/@500/9837945080.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/136/@500/9837945080.webp',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/136/@500/9837945080.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/136/@500/9837945080.jpeg',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/136/@500/9837945080.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/136/@768/9837945080.avif',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/136/@768/9837945080.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/136/@768/9837945080.webp',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/136/@768/9837945080.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/136/@768/9837945080.jpeg',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/136/@768/9837945080.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'Oppbevaringsbag for ladekabel  - 9837945080',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleNumber',
                                                        content: {
                                                            text: '9837945080',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleName',
                                                        content: {
                                                            text: 'Oppbevaringsbag',
                                                        },
                                                    },
                                                    {
                                                        id: 'brandSpecific',
                                                        content: {
                                                            value: true,
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2db671b020008b114c0',
                                                    name: 'Peugeot',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'accessoryTimeAssembly',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryIndicativePriceExcludingVatAndAssembly',
                                    content: {
                                        number: 610,
                                    },
                                },
                                {
                                    id: 'accessoryAssemblyPriceExcludingVat',
                                    content: {
                                        number: 1120,
                                    },
                                },
                                {
                                    id: 'accessoryVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryVatEl',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatIce',
                                    content: {
                                        number: 770,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatEl',
                                    content: {
                                        number: 770,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatIce',
                                    content: {
                                        number: 616,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatEl',
                                    content: {
                                        number: 616,
                                    },
                                },
                                {
                                    id: 'accessoryRetailPriceExcludingVat',
                                    content: {
                                        number: 518,
                                    },
                                },
                                {
                                    id: 'accessoryRetailerMargin',
                                    content: {
                                        number: 91,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'accessory',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2df3419880008366c8d',
                                                name: 'Ladekabel 9828542180',
                                                defaultVariant: {
                                                    sku: '9828542180',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/150/9828542180.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/150/9828542180.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/150/@100/9828542180.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/150/@100/9828542180.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/150/@100/9828542180.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/150/@100/9828542180.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/150/@100/9828542180.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/150/@100/9828542180.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/150/@200/9828542180.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/150/@200/9828542180.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/150/@200/9828542180.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/150/@200/9828542180.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/150/@200/9828542180.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/150/@200/9828542180.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/150/@500/9828542180.avif',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/150/@500/9828542180.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/150/@500/9828542180.webp',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/150/@500/9828542180.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/150/@500/9828542180.jpeg',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/150/@500/9828542180.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/150/@768/9828542180.avif',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/150/@768/9828542180.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/150/@768/9828542180.webp',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/150/@768/9828542180.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/150/@768/9828542180.jpeg',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/150/@768/9828542180.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'MODUS 3-KABEL 1-FASET 7,4 KW 6 M - 9828542180',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleNumber',
                                                        content: {
                                                            text: '9828542180',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleName',
                                                        content: {
                                                            text: 'Ladekabel',
                                                        },
                                                    },
                                                    {
                                                        id: 'brandSpecific',
                                                        content: {
                                                            value: true,
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2db671b020008b114c0',
                                                    name: 'Peugeot',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'accessoryTimeAssembly',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryIndicativePriceExcludingVatAndAssembly',
                                    content: {
                                        number: 3011,
                                    },
                                },
                                {
                                    id: 'accessoryAssemblyPriceExcludingVat',
                                    content: {
                                        number: 1120,
                                    },
                                },
                                {
                                    id: 'accessoryVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryVatEl',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatIce',
                                    content: {
                                        number: 3770,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatEl',
                                    content: {
                                        number: 3020,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatIce',
                                    content: {
                                        number: 3016,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatEl',
                                    content: {
                                        number: 3020,
                                    },
                                },
                                {
                                    id: 'accessoryRetailPriceExcludingVat',
                                    content: {
                                        number: 2560,
                                    },
                                },
                                {
                                    id: 'accessoryRetailerMargin',
                                    content: {
                                        number: 452,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'accessory',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2e03419880008366c93',
                                                name: 'Terskelbeskytter 1648527480',
                                                defaultVariant: {
                                                    sku: '1648527480',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/137/1648527480.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/137/1648527480.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/137/@100/1648527480.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/137/@100/1648527480.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/137/@100/1648527480.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/137/@100/1648527480.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/137/@100/1648527480.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/137/@100/1648527480.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/137/@200/1648527480.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/137/@200/1648527480.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/137/@200/1648527480.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/137/@200/1648527480.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/137/@200/1648527480.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/137/@200/1648527480.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/137/@500/1648527480.avif',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/137/@500/1648527480.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/137/@500/1648527480.webp',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/137/@500/1648527480.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/137/@500/1648527480.jpeg',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/137/@500/1648527480.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/137/@768/1648527480.avif',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/137/@768/1648527480.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/137/@768/1648527480.webp',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/137/@768/1648527480.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/137/@768/1648527480.jpeg',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/137/@768/1648527480.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/137/@1024/1648527480.avif',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/137/@1024/1648527480.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/137/@1024/1648527480.webp',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/137/@1024/1648527480.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/137/@1024/1648527480.jpeg',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/137/@1024/1648527480.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'Terskelbeskytter bagasjerom (GJENNOMSIKTIG FILM) - 1648527480',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleNumber',
                                                        content: {
                                                            text: '1648527480',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleName',
                                                        content: {
                                                            text: 'Terskelbeskytter',
                                                        },
                                                    },
                                                    {
                                                        id: 'brandSpecific',
                                                        content: {
                                                            value: true,
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2db671b020008b114c0',
                                                    name: 'Peugeot',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'accessoryTimeAssembly',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryIndicativePriceExcludingVatAndAssembly',
                                    content: {
                                        number: 466,
                                    },
                                },
                                {
                                    id: 'accessoryAssemblyPriceExcludingVat',
                                    content: {
                                        number: 1120,
                                    },
                                },
                                {
                                    id: 'accessoryVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryVatEl',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatIce',
                                    content: {
                                        number: 590,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatEl',
                                    content: {
                                        number: 470,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatIce',
                                    content: {
                                        number: 472,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatEl',
                                    content: {
                                        number: 470,
                                    },
                                },
                                {
                                    id: 'accessoryRetailPriceExcludingVat',
                                    content: {
                                        number: 396,
                                    },
                                },
                                {
                                    id: 'accessoryRetailerMargin',
                                    content: {
                                        number: 70,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'accessory',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2df671b020008b114fc',
                                                name: 'Gummimatter 1656154380',
                                                defaultVariant: {
                                                    sku: '1656154380',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/151/1656154380.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/151/1656154380.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/151/@100/1656154380.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/151/@100/1656154380.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/151/@100/1656154380.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/151/@100/1656154380.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/151/@100/1656154380.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/151/@100/1656154380.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/151/@200/1656154380.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/151/@200/1656154380.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/151/@200/1656154380.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/151/@200/1656154380.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/151/@200/1656154380.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/151/@200/1656154380.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/151/@500/1656154380.avif',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/151/@500/1656154380.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/151/@500/1656154380.webp',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/151/@500/1656154380.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/151/@500/1656154380.jpeg',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/151/@500/1656154380.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/151/@768/1656154380.avif',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/151/@768/1656154380.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/151/@768/1656154380.webp',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/151/@768/1656154380.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/151/@768/1656154380.jpeg',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/151/@768/1656154380.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/151/@1024/1656154380.avif',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/151/@1024/1656154380.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/151/@1024/1656154380.webp',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/151/@1024/1656154380.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/151/@1024/1656154380.jpeg',
                                                                    width: 1024,
                                                                    key: 'bos-no-ecom-2/21/4/26/151/@1024/1656154380.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'Gummimatter foran og bak - 1656154380',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleNumber',
                                                        content: {
                                                            text: '1656154380',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleName',
                                                        content: {
                                                            text: 'Gummimatter',
                                                        },
                                                    },
                                                    {
                                                        id: 'brandSpecific',
                                                        content: {
                                                            value: true,
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2db671b020008b114c0',
                                                    name: 'Peugeot',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'accessoryTimeAssembly',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryIndicativePriceExcludingVatAndAssembly',
                                    content: {
                                        number: 879,
                                    },
                                },
                                {
                                    id: 'accessoryAssemblyPriceExcludingVat',
                                    content: {
                                        number: 1120,
                                    },
                                },
                                {
                                    id: 'accessoryVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryVatEl',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatIce',
                                    content: {
                                        number: 1100,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatEl',
                                    content: {
                                        number: 880,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatIce',
                                    content: {
                                        number: 880,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatEl',
                                    content: {
                                        number: 880,
                                    },
                                },
                                {
                                    id: 'accessoryRetailPriceExcludingVat',
                                    content: {
                                        number: 747,
                                    },
                                },
                                {
                                    id: 'accessoryRetailerMargin',
                                    content: {
                                        number: 132,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'accessory',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2e0671b020008b11503',
                                                name: 'Parkeringsur BOSPARKMINI',
                                                defaultVariant: {
                                                    sku: 'BOSPARKMINI',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/173/bosparkmini.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/173/bosparkmini.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/173/@100/bosparkmini.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/173/@100/bosparkmini.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/173/@100/bosparkmini.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/173/@100/bosparkmini.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/173/@100/bosparkmini.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/173/@100/bosparkmini.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/173/@200/bosparkmini.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/173/@200/bosparkmini.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/173/@200/bosparkmini.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/173/@200/bosparkmini.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/173/@200/bosparkmini.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/173/@200/bosparkmini.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'Digitalt mini - parkeringsur  - BOSPARKMINI',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleNumber',
                                                        content: {
                                                            text: 'BOSPARKMINI',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleName',
                                                        content: {
                                                            text: 'Parkeringsur',
                                                        },
                                                    },
                                                    {
                                                        id: 'brandSpecific',
                                                        content: {
                                                            value: false,
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2db671b020008b114be',
                                                    name: 'Bertel O. Steen',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'accessoryTimeAssembly',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryIndicativePriceExcludingVatAndAssembly',
                                    content: {
                                        number: 399,
                                    },
                                },
                                {
                                    id: 'accessoryAssemblyPriceExcludingVat',
                                    content: {
                                        number: 1120,
                                    },
                                },
                                {
                                    id: 'accessoryVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryVatEl',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatIce',
                                    content: {
                                        number: 500,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatEl',
                                    content: {
                                        number: 400,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatIce',
                                    content: {
                                        number: 400,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatEl',
                                    content: {
                                        number: 400,
                                    },
                                },
                                {
                                    id: 'accessoryRetailPriceExcludingVat',
                                    content: {
                                        number: 339,
                                    },
                                },
                                {
                                    id: 'accessoryRetailerMargin',
                                    content: {
                                        number: 60,
                                    },
                                },
                            ],
                        ],
                    },
                },
                {
                    id: 'wheels',
                    content: {
                        chunks: [
                            [
                                {
                                    id: 'wheelSet',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2da671b020008b114ae',
                                                name: 'NOWA03977/NOWA03977',
                                                defaultVariant: {
                                                    sku: 'NOWA03977/NOWA03977',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/186/nowa03977.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/186/nowa03977.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/186/@100/nowa03977.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/186/@100/nowa03977.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/186/@100/nowa03977.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/186/@100/nowa03977.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/186/@100/nowa03977.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/186/@100/nowa03977.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/186/@200/nowa03977.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/186/@200/nowa03977.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/186/@200/nowa03977.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/186/@200/nowa03977.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/186/@200/nowa03977.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/186/@200/nowa03977.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/186/@500/nowa03977.avif',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/186/@500/nowa03977.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/186/@500/nowa03977.webp',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/186/@500/nowa03977.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/186/@500/nowa03977.jpeg',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/186/@500/nowa03977.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'tireManufacturer',
                                                        content: {
                                                            text: 'Nokian',
                                                        },
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: "98281860XY -17'' SALAMANCA ALU m/215/45R17",
                                                        },
                                                    },
                                                    {
                                                        id: 'nowaCodes',
                                                        content: {
                                                            chunks: [
                                                                [
                                                                    {
                                                                        id: 'code',
                                                                        content: {
                                                                            text: 'NOWA03977/NOWA03977',
                                                                        },
                                                                    },
                                                                    {
                                                                        id: 'front',
                                                                        content: {
                                                                            text: 'NOWA03977',
                                                                        },
                                                                    },
                                                                    {
                                                                        id: 'rear',
                                                                        content: {
                                                                            text: 'NOWA03977',
                                                                        },
                                                                    },
                                                                ],
                                                            ],
                                                        },
                                                    },
                                                    {
                                                        id: 'tireType',
                                                        content: {
                                                            text: 'Piggfri',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2d8671b020008b11499',
                                                    name: 'Peugeot',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'isWheelSetRecommended',
                                    content: {
                                        value: false,
                                    },
                                },
                                {
                                    id: 'wheelSetVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'wheelSetVatEl',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceBeforeVat',
                                    content: {
                                        number: 18900,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceIncludingVatIce',
                                    content: {
                                        number: 23625,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceIncludingVatEl',
                                    content: {
                                        number: 18900,
                                    },
                                },
                                {
                                    id: 'wheelSetRetailerPriceExcludingVat',
                                    content: {
                                        number: 16065,
                                    },
                                },
                                {
                                    id: 'wheelSetRetailerMargin',
                                    content: {
                                        number: 2835,
                                    },
                                },
                                {
                                    id: 'wheelSetIndicativeSalesPriceExcludingVat',
                                    content: {
                                        number: 18884,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'wheelSet',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2da330a3f000a8b3a1f',
                                                name: 'NOWA03842/NOWA03842',
                                                defaultVariant: {
                                                    sku: 'NOWA03842/NOWA03842',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/184/nowa03842.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/184/nowa03842.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/184/@100/nowa03842.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/184/@100/nowa03842.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/184/@100/nowa03842.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/184/@100/nowa03842.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/184/@100/nowa03842.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/184/@100/nowa03842.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/184/@200/nowa03842.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/184/@200/nowa03842.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/184/@200/nowa03842.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/184/@200/nowa03842.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/184/@200/nowa03842.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/184/@200/nowa03842.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'tireManufacturer',
                                                        content: {
                                                            text: 'Nokian',
                                                        },
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: '98281855ZV - 16"  JORDAN ALU 195/55R16',
                                                        },
                                                    },
                                                    {
                                                        id: 'nowaCodes',
                                                        content: {
                                                            chunks: [
                                                                [
                                                                    {
                                                                        id: 'code',
                                                                        content: {
                                                                            text: 'NOWA03842/NOWA03842',
                                                                        },
                                                                    },
                                                                    {
                                                                        id: 'front',
                                                                        content: {
                                                                            text: 'NOWA03842',
                                                                        },
                                                                    },
                                                                    {
                                                                        id: 'rear',
                                                                        content: {
                                                                            text: 'NOWA03842',
                                                                        },
                                                                    },
                                                                ],
                                                            ],
                                                        },
                                                    },
                                                    {
                                                        id: 'tireType',
                                                        content: {
                                                            text: 'Pigg',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2d8671b020008b11499',
                                                    name: 'Peugeot',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'isWheelSetRecommended',
                                    content: {
                                        value: false,
                                    },
                                },
                                {
                                    id: 'wheelSetVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'wheelSetVatEl',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceBeforeVat',
                                    content: {
                                        number: 13000,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceIncludingVatIce',
                                    content: {
                                        number: 16250,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceIncludingVatEl',
                                    content: {
                                        number: 13000,
                                    },
                                },
                                {
                                    id: 'wheelSetRetailerPriceExcludingVat',
                                    content: {
                                        number: 11050,
                                    },
                                },
                                {
                                    id: 'wheelSetRetailerMargin',
                                    content: {
                                        number: 1950,
                                    },
                                },
                                {
                                    id: 'wheelSetIndicativeSalesPriceExcludingVat',
                                    content: {
                                        number: 12916,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'wheelSet',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2da671b020008b114b8',
                                                name: 'NOWA03843/NOWA03843',
                                                defaultVariant: {
                                                    sku: 'NOWA03843/NOWA03843',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/187/nowa03843.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/187/nowa03843.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/187/@100/nowa03843.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/187/@100/nowa03843.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/187/@100/nowa03843.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/187/@100/nowa03843.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/187/@100/nowa03843.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/187/@100/nowa03843.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/187/@200/nowa03843.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/187/@200/nowa03843.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/187/@200/nowa03843.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/187/@200/nowa03843.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/187/@200/nowa03843.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/187/@200/nowa03843.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/187/@500/nowa03843.avif',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/187/@500/nowa03843.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/187/@500/nowa03843.webp',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/187/@500/nowa03843.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/187/@500/nowa03843.jpeg',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/187/@500/nowa03843.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/187/@768/nowa03843.avif',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/187/@768/nowa03843.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/187/@768/nowa03843.webp',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/187/@768/nowa03843.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/187/@768/nowa03843.jpeg',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/187/@768/nowa03843.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'tireManufacturer',
                                                        content: {
                                                            text: 'Nokian',
                                                        },
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: '98281855ZV - 16"  JORDAN ALU 195/55R16',
                                                        },
                                                    },
                                                    {
                                                        id: 'nowaCodes',
                                                        content: {
                                                            chunks: [
                                                                [
                                                                    {
                                                                        id: 'code',
                                                                        content: {
                                                                            text: 'NOWA03843/NOWA03843',
                                                                        },
                                                                    },
                                                                    {
                                                                        id: 'front',
                                                                        content: {
                                                                            text: 'NOWA03843',
                                                                        },
                                                                    },
                                                                    {
                                                                        id: 'rear',
                                                                        content: {
                                                                            text: 'NOWA03843',
                                                                        },
                                                                    },
                                                                ],
                                                            ],
                                                        },
                                                    },
                                                    {
                                                        id: 'tireType',
                                                        content: {
                                                            text: 'Piggfri',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2d8671b020008b11499',
                                                    name: 'Peugeot',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'isWheelSetRecommended',
                                    content: {
                                        value: true,
                                    },
                                },
                                {
                                    id: 'wheelSetVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'wheelSetVatEl',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceBeforeVat',
                                    content: {
                                        number: 12800,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceIncludingVatIce',
                                    content: {
                                        number: 16000,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceIncludingVatEl',
                                    content: {
                                        number: 12800,
                                    },
                                },
                                {
                                    id: 'wheelSetRetailerPriceExcludingVat',
                                    content: {
                                        number: 10880,
                                    },
                                },
                                {
                                    id: 'wheelSetRetailerMargin',
                                    content: {
                                        number: 1920,
                                    },
                                },
                                {
                                    id: 'wheelSetIndicativeSalesPriceExcludingVat',
                                    content: {
                                        number: 12733,
                                    },
                                },
                            ],
                        ],
                    },
                },
                {
                    id: 'interiors',
                    content: null,
                },
            ],
            model: {
                id: '608fe2c2671b020008b1130f',
                name: 'e208',
                components: [
                    {
                        id: 'manufacturer',
                        content: null,
                    },
                    {
                        id: 'marketing',
                        content: null,
                    },
                    {
                        id: 'availableOnBos',
                        content: null,
                    },
                    {
                        id: 'availableOnNext',
                        content: {
                            value: true,
                        },
                    },
                    {
                        id: 'quoteText',
                        content: null,
                    },
                    {
                        id: 'campaignText',
                        content: null,
                    },
                    {
                        id: 'carType',
                        content: {
                            text: 'EL',
                        },
                    },
                    {
                        id: 'allRelatedTrim',
                        content: null,
                    },
                    {
                        id: 'sellableTrimsOnBos',
                        content: null,
                    },
                    {
                        id: 'productCardFeaturedTrim',
                        content: null,
                    },
                    {
                        id: 'properties',
                        content: {
                            sections: [
                                {
                                    title: 'Car',
                                    properties: [
                                        {
                                            key: 'bodyType',
                                            value: 'Kombi',
                                        },
                                        {
                                            key: 'luggageVolume',
                                            value: '265',
                                        },
                                        {
                                            key: 'numberOfSeats',
                                            value: '5',
                                        },
                                        {
                                            key: 'modelYear',
                                            value: '2021',
                                        },
                                        {
                                            key: 'towingCapacity',
                                            value: '0',
                                        },
                                        {
                                            key: 'roofCapacity',
                                            value: '75 kg',
                                        },
                                    ],
                                },
                                {
                                    title: 'Motor',
                                    properties: [
                                        {
                                            key: 'fuel',
                                            value: 'Elektrisk',
                                        },
                                        {
                                            key: 'powertrain',
                                            value: 'Forhjulsdrift',
                                        },
                                        {
                                            key: 'transmission',
                                            value: 'Automat',
                                        },
                                        {
                                            key: 'consumption',
                                            value: '147 Wh/km',
                                        },
                                        {
                                            key: 'effect',
                                            value: '136 hk',
                                        },
                                    ],
                                },
                                {
                                    title: 'Electric',
                                    properties: [
                                        {
                                            key: 'electricRange',
                                            value: '340 km',
                                        },
                                        {
                                            key: 'batteryCapacity',
                                            value: '50 kWh',
                                        },
                                        {
                                            key: 'chargingCapacityAC',
                                            value: '7,4 kW',
                                        },
                                        {
                                            key: 'chargingCapacityDC',
                                            value: '100 kW',
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                ],
                modelSeries: {
                    id: '60cc62095e0940000944f5b7',
                    name: 'e208',
                    components: [],
                    manufacturer: {
                        id: '608fe2c13419880008366a96',
                        name: 'Peugeot',
                        components: [
                            {
                                id: 'logo',
                                content: null,
                            },
                            {
                                id: 'description',
                                content: {
                                    plainText: [''],
                                },
                            },
                        ],
                    },
                },
            },
        },
        salesPackage2: {
            id: '608fe2e73419880008366cc0',
            name: 'Classic 39,2 kW',
            defaultVariant: {
                sku: 'J2W5ZGZ7Z D079',
                priceVariants: [
                    {
                        identifier: 'default',
                        price: 340300,
                    },
                ],
                images: [
                    {
                        url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/kia-e-soul-my19-design-w.jpg',
                        key: 'bos-no-ecom-2/21/4/26/43/kia-e-soul-my19-design-w.jpg',
                        variants: [
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-design-w.avif',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-design-w.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-design-w.webp',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-design-w.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-design-w.jpeg',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-design-w.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-design-w.avif',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-design-w.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-design-w.webp',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-design-w.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-design-w.jpeg',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-design-w.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-design-w.avif',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-design-w.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-design-w.webp',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-design-w.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-design-w.jpeg',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-design-w.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-design-w.avif',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-design-w.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-design-w.webp',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-design-w.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-design-w.jpeg',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-design-w.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@1024/kia-e-soul-my19-design-w.avif',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/43/@1024/kia-e-soul-my19-design-w.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@1024/kia-e-soul-my19-design-w.webp',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/43/@1024/kia-e-soul-my19-design-w.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@1024/kia-e-soul-my19-design-w.jpeg',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/43/@1024/kia-e-soul-my19-design-w.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@1366/kia-e-soul-my19-design-w.avif',
                                width: 1366,
                                key: 'bos-no-ecom-2/21/4/26/43/@1366/kia-e-soul-my19-design-w.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@1366/kia-e-soul-my19-design-w.webp',
                                width: 1366,
                                key: 'bos-no-ecom-2/21/4/26/43/@1366/kia-e-soul-my19-design-w.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@1366/kia-e-soul-my19-design-w.jpeg',
                                width: 1366,
                                key: 'bos-no-ecom-2/21/4/26/43/@1366/kia-e-soul-my19-design-w.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@1600/kia-e-soul-my19-design-w.avif',
                                width: 1600,
                                key: 'bos-no-ecom-2/21/4/26/43/@1600/kia-e-soul-my19-design-w.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@1600/kia-e-soul-my19-design-w.webp',
                                width: 1600,
                                key: 'bos-no-ecom-2/21/4/26/43/@1600/kia-e-soul-my19-design-w.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@1600/kia-e-soul-my19-design-w.jpeg',
                                width: 1600,
                                key: 'bos-no-ecom-2/21/4/26/43/@1600/kia-e-soul-my19-design-w.jpeg',
                            },
                        ],
                    },
                    {
                        url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/kia-e-soul-my19-electrify-your-life-w.jpg',
                        key: 'bos-no-ecom-2/21/4/26/43/kia-e-soul-my19-electrify-your-life-w.jpg',
                        variants: [
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-electrify-your-life-w.avif',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-electrify-your-life-w.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-electrify-your-life-w.webp',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-electrify-your-life-w.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-electrify-your-life-w.jpeg',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-electrify-your-life-w.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-electrify-your-life-w.avif',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-electrify-your-life-w.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-electrify-your-life-w.webp',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-electrify-your-life-w.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-electrify-your-life-w.jpeg',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-electrify-your-life-w.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-electrify-your-life-w.avif',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-electrify-your-life-w.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-electrify-your-life-w.webp',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-electrify-your-life-w.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-electrify-your-life-w.jpeg',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-electrify-your-life-w.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-electrify-your-life-w.avif',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-electrify-your-life-w.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-electrify-your-life-w.webp',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-electrify-your-life-w.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-electrify-your-life-w.jpeg',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-electrify-your-life-w.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@1024/kia-e-soul-my19-electrify-your-life-w.avif',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/43/@1024/kia-e-soul-my19-electrify-your-life-w.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@1024/kia-e-soul-my19-electrify-your-life-w.webp',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/43/@1024/kia-e-soul-my19-electrify-your-life-w.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@1024/kia-e-soul-my19-electrify-your-life-w.jpeg',
                                width: 1024,
                                key: 'bos-no-ecom-2/21/4/26/43/@1024/kia-e-soul-my19-electrify-your-life-w.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@1366/kia-e-soul-my19-electrify-your-life-w.avif',
                                width: 1366,
                                key: 'bos-no-ecom-2/21/4/26/43/@1366/kia-e-soul-my19-electrify-your-life-w.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@1366/kia-e-soul-my19-electrify-your-life-w.webp',
                                width: 1366,
                                key: 'bos-no-ecom-2/21/4/26/43/@1366/kia-e-soul-my19-electrify-your-life-w.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@1366/kia-e-soul-my19-electrify-your-life-w.jpeg',
                                width: 1366,
                                key: 'bos-no-ecom-2/21/4/26/43/@1366/kia-e-soul-my19-electrify-your-life-w.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@1600/kia-e-soul-my19-electrify-your-life-w.avif',
                                width: 1600,
                                key: 'bos-no-ecom-2/21/4/26/43/@1600/kia-e-soul-my19-electrify-your-life-w.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@1600/kia-e-soul-my19-electrify-your-life-w.webp',
                                width: 1600,
                                key: 'bos-no-ecom-2/21/4/26/43/@1600/kia-e-soul-my19-electrify-your-life-w.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@1600/kia-e-soul-my19-electrify-your-life-w.jpeg',
                                width: 1600,
                                key: 'bos-no-ecom-2/21/4/26/43/@1600/kia-e-soul-my19-electrify-your-life-w.jpeg',
                            },
                        ],
                    },
                    {
                        url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/kia-e-soul-my19-select-your-range.jpg',
                        key: 'bos-no-ecom-2/21/4/26/43/kia-e-soul-my19-select-your-range.jpg',
                        variants: [
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-select-your-range.avif',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-select-your-range.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-select-your-range.webp',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-select-your-range.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-select-your-range.jpeg',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-select-your-range.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-select-your-range.avif',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-select-your-range.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-select-your-range.webp',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-select-your-range.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-select-your-range.jpeg',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-select-your-range.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-select-your-range.avif',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-select-your-range.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-select-your-range.webp',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-select-your-range.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-select-your-range.jpeg',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-select-your-range.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-select-your-range.avif',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-select-your-range.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-select-your-range.webp',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-select-your-range.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-select-your-range.jpeg',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-select-your-range.jpeg',
                            },
                        ],
                    },
                    {
                        url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/kia-e-soul-my19-the-chic-electric.jpg',
                        key: 'bos-no-ecom-2/21/4/26/43/kia-e-soul-my19-the-chic-electric.jpg',
                        variants: [
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-the-chic-electric.avif',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-the-chic-electric.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-the-chic-electric.webp',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-the-chic-electric.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-the-chic-electric.jpeg',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-the-chic-electric.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-the-chic-electric.avif',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-the-chic-electric.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-the-chic-electric.webp',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-the-chic-electric.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-the-chic-electric.jpeg',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-the-chic-electric.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-the-chic-electric.avif',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-the-chic-electric.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-the-chic-electric.webp',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-the-chic-electric.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-the-chic-electric.jpeg',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-the-chic-electric.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-the-chic-electric.avif',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-the-chic-electric.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-the-chic-electric.webp',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-the-chic-electric.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-the-chic-electric.jpeg',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-the-chic-electric.jpeg',
                            },
                        ],
                    },
                    {
                        url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/kia-e-soul-my19-clean-fun.jpg',
                        key: 'bos-no-ecom-2/21/4/26/43/kia-e-soul-my19-clean-fun.jpg',
                        variants: [
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-clean-fun.avif',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-clean-fun.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-clean-fun.webp',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-clean-fun.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-clean-fun.jpeg',
                                width: 100,
                                key: 'bos-no-ecom-2/21/4/26/43/@100/kia-e-soul-my19-clean-fun.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-clean-fun.avif',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-clean-fun.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-clean-fun.webp',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-clean-fun.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-clean-fun.jpeg',
                                width: 200,
                                key: 'bos-no-ecom-2/21/4/26/43/@200/kia-e-soul-my19-clean-fun.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-clean-fun.avif',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-clean-fun.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-clean-fun.webp',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-clean-fun.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-clean-fun.jpeg',
                                width: 500,
                                key: 'bos-no-ecom-2/21/4/26/43/@500/kia-e-soul-my19-clean-fun.jpeg',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-clean-fun.avif',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-clean-fun.avif',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-clean-fun.webp',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-clean-fun.webp',
                            },
                            {
                                url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-clean-fun.jpeg',
                                width: 768,
                                key: 'bos-no-ecom-2/21/4/26/43/@768/kia-e-soul-my19-clean-fun.jpeg',
                            },
                        ],
                    },
                ],
            },
            components: [
                {
                    id: 'modelSeries',
                    content: null,
                },
                {
                    id: 'campaignText',
                    content: null,
                },
                {
                    id: 'seriesBrand',
                    content: {
                        text: 'J2W5ZGZ7Z',
                    },
                },
                {
                    id: 'salesArticle',
                    content: {
                        text: 'Kia e-Soul (SK3) automat',
                    },
                },
                {
                    id: 'salesPackage',
                    content: {
                        text: 'Classic',
                    },
                },
                {
                    id: 'quoteText',
                    content: {
                        plainText: [''],
                    },
                },
                {
                    id: 'standardInteriorCode',
                    content: {
                        text: 'WK',
                    },
                },
                {
                    id: 'standardRimCode',
                    content: null,
                },
                {
                    id: 'uniqueBrandIdentifier',
                    content: {
                        text: 'D079',
                    },
                },
                {
                    id: 'standardEquipment',
                    content: {
                        chunks: [
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'LED tåkelys',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'LED kjørelys foran',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'LED baklys',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Filskiftvarsler med Lane Keeping Assist System',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Dekktrykksensorer',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Elektrisk justerbare og oppvarmede sidespeil',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Automatisk nødbremsesystem m/fotgjengergjenkjenning (AEB)',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'ISOFIX barnesetefester',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Kjørecomputer',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Bakkestartassistent',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Hendler på rattet for justering av regenerativ bremsing',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Tilt / teleskopratt',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Høydejusterbar førerstol',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Oppvarmede seter foran',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Elektrisk håndbrekk m/ Auto Hold funksjon',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Elektriske vinduer foran og bak',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Automatisk lyskontroll (ALC)',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Automatisk klimaanlegg',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Nedfellbar bakseterygg delt 60:40',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Batterivarmer',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'eCall',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'DAB radio',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Understellsbehandling -Ladekabel Type 2 til Type 2 og ladekabel med schuko kontakt',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'standardEquipmentName',
                                    content: {
                                        text: 'Bagasjeromsmatte og gummimatter i kupé',
                                    },
                                },
                            ],
                        ],
                    },
                },
                {
                    id: 'packageEquipment',
                    content: {
                        chunks: [
                            [
                                {
                                    id: 'packageEquipmentName',
                                    content: {
                                        text: '17" alufelger',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'packageEquipmentName',
                                    content: {
                                        text: 'BI LED hovedlys',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'packageEquipmentName',
                                    content: {
                                        text: 'Smart Key nøkkelfritt system',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'packageEquipmentName',
                                    content: {
                                        text: 'Oppvarmet og skinntrukket multifunksjonsratt',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'packageEquipmentName',
                                    content: {
                                        text: 'Fjernlysassistent',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'packageEquipmentName',
                                    content: {
                                        text: 'Adaptiv cruise control m/Stop&Go',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'packageEquipmentName',
                                    content: {
                                        text: 'Lane Following Assist',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'packageEquipmentName',
                                    content: {
                                        text: 'Ryggekamera m/ dynamisk guiding',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'packageEquipmentName',
                                    content: {
                                        text: '7" multimedieskjerm',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'packageEquipmentName',
                                    content: {
                                        text: 'Støtte for Apple CarPlay og Android Auto',
                                    },
                                },
                            ],
                        ],
                    },
                },
                {
                    id: 'equipmentHighlights',
                    content: {
                        chunks: [
                            [
                                {
                                    id: 'equipmentHighlightName',
                                    content: {
                                        text: '17" alufelger',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'equipmentHighlightName',
                                    content: {
                                        text: 'Adaptive Cruisecontroll',
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'equipmentHighlightName',
                                    content: {
                                        text: "7'' multimedieskjerm",
                                    },
                                },
                            ],
                        ],
                    },
                },
                {
                    id: 'prices',
                    content: {
                        chunks: [
                            [
                                {
                                    id: 'netCustomerPriceIncludingVat',
                                    content: {
                                        number: 340300,
                                    },
                                },
                                {
                                    id: 'leasingBasisPrice',
                                    content: {
                                        number: 340300,
                                    },
                                },
                                {
                                    id: 'listPriceCar',
                                    content: {
                                        number: 311900,
                                    },
                                },
                                {
                                    id: 'listPricePackageCodes',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'importerSupportExcludingMva',
                                    content: {
                                        number: -15000,
                                    },
                                },
                                {
                                    id: 'leasingExtraCustomerAdvantage',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'packageDiscountWinterWheelsIncludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'customerAdvantageCarIncludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'deliveryCharge',
                                    content: {
                                        number: 8000,
                                    },
                                },
                                {
                                    id: 'vatCode',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'vehicleRoadTax',
                                    content: {
                                        number: 2400,
                                    },
                                },
                                {
                                    id: 'grossCustomerPriceExcluding',
                                    content: {
                                        number: 311900,
                                    },
                                },
                                {
                                    id: 'indicativePriceExcludingVat',
                                    content: {
                                        number: 309500,
                                    },
                                },
                                {
                                    id: 'retailerSupportExcludingVat',
                                    content: {
                                        number: 15000,
                                    },
                                },
                                {
                                    id: 'totalCustomerAdvantageIncludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'totalCustomerAdvantageExcludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'winterTiresWithMarkedPack',
                                    content: {
                                        number: 20400,
                                    },
                                },
                                {
                                    id: 'wreckage',
                                    content: {
                                        number: 2400,
                                    },
                                },
                                {
                                    id: 'dealerMarginCar',
                                    content: {
                                        number: 4,
                                    },
                                },
                                {
                                    id: 'dealerMarginPackageCodes',
                                    content: {
                                        number: 14,
                                    },
                                },
                                {
                                    id: 'retailerBasicMargin',
                                    content: {
                                        number: 12380,
                                    },
                                },
                                {
                                    id: 'retailerCampaignMarginLeasing',
                                    content: {
                                        number: 27380,
                                    },
                                },
                                {
                                    id: 'retailerCampaignMarginSale',
                                    content: {
                                        number: 27380,
                                    },
                                },
                                {
                                    id: 'residualValue3y30',
                                    content: {
                                        number: 194481,
                                    },
                                },
                                {
                                    id: 'residualValue3y45',
                                    content: {
                                        number: 173526,
                                    },
                                },
                                {
                                    id: 'residualValue3y60',
                                    content: {
                                        number: 164169,
                                    },
                                },
                                {
                                    id: 'residualValue4y40',
                                    content: {
                                        number: 154812,
                                    },
                                },
                                {
                                    id: 'residualValue4y60',
                                    content: {
                                        number: 145455,
                                    },
                                },
                                {
                                    id: 'leasingDepositExcludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'oneTimeLeasingFeeIncludingVat',
                                    content: {
                                        number: 4250,
                                    },
                                },
                                {
                                    id: 'oneTimeLoanFee',
                                    content: {
                                        number: 4250,
                                    },
                                },
                                {
                                    id: 'invoiceFeeLeasingIncludingVat',
                                    content: {
                                        number: 85,
                                    },
                                },
                                {
                                    id: 'invoiceFeeLoan',
                                    content: {
                                        number: 85,
                                    },
                                },
                                {
                                    id: 'leasingRate',
                                    content: {
                                        number: 3.8,
                                    },
                                },
                                {
                                    id: 'loanRate',
                                    content: {
                                        number: 3.8,
                                    },
                                },
                                {
                                    id: 'leasingDepositIncludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'leasingDepositIncludingVatAndOneTimeFee',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'calculationBaseLeasing',
                                    content: {
                                        number: 340300,
                                    },
                                },
                                {
                                    id: 'monthlyLeasing3y30',
                                    content: {
                                        number: 4978,
                                    },
                                },
                                {
                                    id: 'totalLeasing3y30',
                                    content: {
                                        number: 183442,
                                    },
                                },
                                {
                                    id: 'monthlyLeasing3y45',
                                    content: {
                                        number: 5526,
                                    },
                                },
                                {
                                    id: 'totalLeasing3y45',
                                    content: {
                                        number: 203196,
                                    },
                                },
                                {
                                    id: 'monthlyLeasing4y40',
                                    content: {
                                        number: 4732,
                                    },
                                },
                                {
                                    id: 'totalLeasing4y40',
                                    content: {
                                        number: 231390,
                                    },
                                },
                                {
                                    id: 'monthlyLoan5y35Equity',
                                    content: {
                                        number: 4217,
                                    },
                                },
                                {
                                    id: 'totalLoanCost5y35Equity',
                                    content: {
                                        number: 372101,
                                    },
                                },
                                {
                                    id: 'shortLegalTextLeasing3y30',
                                    content: {
                                        plainText: ['Startleie 0 kr / 36 mnd / 30 000 km / Nom. Rente 3.,8%'],
                                    },
                                },
                                {
                                    id: 'longLegalTextLeasing3y30',
                                    content: null,
                                },
                                {
                                    id: 'shortLegalTextLeasing3y45',
                                    content: {
                                        plainText: ['Startleie 0 kr / 36 mnd / 45 000 km / Nom. Rente 3.,8%'],
                                    },
                                },
                                {
                                    id: 'longLegalTextLeasing3y45',
                                    content: null,
                                },
                                {
                                    id: 'shortLegalTextLeasing4y40',
                                    content: {
                                        plainText: ['Startleie 0 kr / 48 mnd / 40 000 km / Nom. Rente 3.,8%'],
                                    },
                                },
                                {
                                    id: 'longLegalTextLeasing4y40',
                                    content: null,
                                },
                                {
                                    id: 'shortLegalTextLoan',
                                    content: {
                                        plainText: ['35 % Egenkapital / 5 År / Nom. rente 3.,8%'],
                                    },
                                },
                                {
                                    id: 'longLegalTextLoan',
                                    content: null,
                                },
                            ],
                        ],
                    },
                },
                {
                    id: 'varnishes',
                    content: {
                        chunks: [
                            [
                                {
                                    id: 'varnish',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2c8330a3f000a8b38db',
                                                name: 'Neptune Blue - B3A',
                                                defaultVariant: {
                                                    sku: 'J2W5ZGZ7Z D079-B3A',
                                                    priceVariants: null,
                                                    images: null,
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'paintDescription',
                                                        content: {
                                                            text: 'Neptune Blue',
                                                        },
                                                    },
                                                    {
                                                        id: 'lacquerDescription',
                                                        content: {
                                                            text: 'Metall',
                                                        },
                                                    },
                                                    {
                                                        id: 'paintCode',
                                                        content: {
                                                            text: 'B3A',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2c2330a3f000a8b3893',
                                                    name: 'Kia',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'varnishImages',
                                    content: null,
                                },
                                {
                                    id: 'isVarnishRecommended',
                                    content: {
                                        value: false,
                                    },
                                },
                                {
                                    id: 'varnishVatCode',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceIncludingVat',
                                    content: {
                                        number: 6490,
                                    },
                                },
                                {
                                    id: 'varnishPriceExcludingVat',
                                    content: {
                                        number: 6490,
                                    },
                                },
                                {
                                    id: 'varnishRetailPrice',
                                    content: {
                                        number: 5581,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginAmount',
                                    content: {
                                        number: 909,
                                    },
                                },
                                {
                                    id: 'varnishStandardPriceIncludingVat',
                                    content: {
                                        number: 6490,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginPercentage',
                                    content: {
                                        number: 14,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'varnish',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2c8671b020008b1136a',
                                                name: 'Cherry Black - 9H',
                                                defaultVariant: {
                                                    sku: 'J2W5ZGZ7Z D079-9H',
                                                    priceVariants: null,
                                                    images: null,
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'paintDescription',
                                                        content: {
                                                            text: 'Cherry Black',
                                                        },
                                                    },
                                                    {
                                                        id: 'lacquerDescription',
                                                        content: {
                                                            text: 'Pearl',
                                                        },
                                                    },
                                                    {
                                                        id: 'paintCode',
                                                        content: {
                                                            text: '9H',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2c2330a3f000a8b3893',
                                                    name: 'Kia',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'varnishImages',
                                    content: null,
                                },
                                {
                                    id: 'isVarnishRecommended',
                                    content: {
                                        value: false,
                                    },
                                },
                                {
                                    id: 'varnishVatCode',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceIncludingVat',
                                    content: {
                                        number: 6490,
                                    },
                                },
                                {
                                    id: 'varnishPriceExcludingVat',
                                    content: {
                                        number: 6490,
                                    },
                                },
                                {
                                    id: 'varnishRetailPrice',
                                    content: {
                                        number: 5581,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginAmount',
                                    content: {
                                        number: 909,
                                    },
                                },
                                {
                                    id: 'varnishStandardPriceIncludingVat',
                                    content: {
                                        number: 6490,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginPercentage',
                                    content: {
                                        number: 14,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'varnish',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2c8671b020008b11366',
                                                name: 'Mars Orange - Cherry Black - SE3',
                                                defaultVariant: {
                                                    sku: 'J2W5ZGZ7Z D079-SE3',
                                                    priceVariants: null,
                                                    images: null,
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'paintDescription',
                                                        content: {
                                                            text: 'Mars Orange - Cherry Black',
                                                        },
                                                    },
                                                    {
                                                        id: 'lacquerDescription',
                                                        content: {
                                                            text: 'Metall/Pearl',
                                                        },
                                                    },
                                                    {
                                                        id: 'paintCode',
                                                        content: {
                                                            text: 'SE3',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2c2330a3f000a8b3893',
                                                    name: 'Kia',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'varnishImages',
                                    content: null,
                                },
                                {
                                    id: 'isVarnishRecommended',
                                    content: {
                                        value: false,
                                    },
                                },
                                {
                                    id: 'varnishVatCode',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceIncludingVat',
                                    content: {
                                        number: 7490,
                                    },
                                },
                                {
                                    id: 'varnishPriceExcludingVat',
                                    content: {
                                        number: 7490,
                                    },
                                },
                                {
                                    id: 'varnishRetailPrice',
                                    content: {
                                        number: 6441,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginAmount',
                                    content: {
                                        number: 1049,
                                    },
                                },
                                {
                                    id: 'varnishStandardPriceIncludingVat',
                                    content: {
                                        number: 7490,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginPercentage',
                                    content: {
                                        number: 14,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'varnish',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2c8330a3f000a8b38de',
                                                name: 'Inferno Red - AJR',
                                                defaultVariant: {
                                                    sku: 'J2W5ZGZ7Z D079-AJR',
                                                    priceVariants: null,
                                                    images: null,
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'paintDescription',
                                                        content: {
                                                            text: 'Inferno Red',
                                                        },
                                                    },
                                                    {
                                                        id: 'lacquerDescription',
                                                        content: {
                                                            text: 'Metall',
                                                        },
                                                    },
                                                    {
                                                        id: 'paintCode',
                                                        content: {
                                                            text: 'AJR',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2c2330a3f000a8b3893',
                                                    name: 'Kia',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'varnishImages',
                                    content: null,
                                },
                                {
                                    id: 'isVarnishRecommended',
                                    content: {
                                        value: false,
                                    },
                                },
                                {
                                    id: 'varnishVatCode',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceIncludingVat',
                                    content: {
                                        number: 6490,
                                    },
                                },
                                {
                                    id: 'varnishPriceExcludingVat',
                                    content: {
                                        number: 6490,
                                    },
                                },
                                {
                                    id: 'varnishRetailPrice',
                                    content: {
                                        number: 5581,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginAmount',
                                    content: {
                                        number: 909,
                                    },
                                },
                                {
                                    id: 'varnishStandardPriceIncludingVat',
                                    content: {
                                        number: 6490,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginPercentage',
                                    content: {
                                        number: 14,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'varnish',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2c8671b020008b1136c',
                                                name: 'Inferno Red - Cherry Black - AH4',
                                                defaultVariant: {
                                                    sku: 'J2W5ZGZ7Z D079-AH4',
                                                    priceVariants: null,
                                                    images: null,
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'paintDescription',
                                                        content: {
                                                            text: 'Inferno Red - Cherry Black',
                                                        },
                                                    },
                                                    {
                                                        id: 'lacquerDescription',
                                                        content: {
                                                            text: 'Metall/Pearl',
                                                        },
                                                    },
                                                    {
                                                        id: 'paintCode',
                                                        content: {
                                                            text: 'AH4',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2c2330a3f000a8b3893',
                                                    name: 'Kia',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'varnishImages',
                                    content: null,
                                },
                                {
                                    id: 'isVarnishRecommended',
                                    content: {
                                        value: false,
                                    },
                                },
                                {
                                    id: 'varnishVatCode',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceIncludingVat',
                                    content: {
                                        number: 7490,
                                    },
                                },
                                {
                                    id: 'varnishPriceExcludingVat',
                                    content: {
                                        number: 7490,
                                    },
                                },
                                {
                                    id: 'varnishRetailPrice',
                                    content: {
                                        number: 6441,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginAmount',
                                    content: {
                                        number: 1049,
                                    },
                                },
                                {
                                    id: 'varnishStandardPriceIncludingVat',
                                    content: {
                                        number: 7490,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginPercentage',
                                    content: {
                                        number: 14,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'varnish',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2c8330a3f000a8b38e2',
                                                name: 'Clear White - Inferno Red - AH1',
                                                defaultVariant: {
                                                    sku: 'J2W5ZGZ7Z D079-AH1',
                                                    priceVariants: null,
                                                    images: null,
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'paintDescription',
                                                        content: {
                                                            text: 'Clear White - Inferno Red',
                                                        },
                                                    },
                                                    {
                                                        id: 'lacquerDescription',
                                                        content: {
                                                            text: 'Standard',
                                                        },
                                                    },
                                                    {
                                                        id: 'paintCode',
                                                        content: {
                                                            text: 'AH1',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2c2330a3f000a8b3893',
                                                    name: 'Kia',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'varnishImages',
                                    content: null,
                                },
                                {
                                    id: 'isVarnishRecommended',
                                    content: {
                                        value: true,
                                    },
                                },
                                {
                                    id: 'varnishVatCode',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceIncludingVat',
                                    content: {
                                        number: 7490,
                                    },
                                },
                                {
                                    id: 'varnishPriceExcludingVat',
                                    content: {
                                        number: 7490,
                                    },
                                },
                                {
                                    id: 'varnishRetailPrice',
                                    content: {
                                        number: 6441,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginAmount',
                                    content: {
                                        number: 1049,
                                    },
                                },
                                {
                                    id: 'varnishStandardPriceIncludingVat',
                                    content: {
                                        number: 7490,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginPercentage',
                                    content: {
                                        number: 14,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'varnish',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2c8330a3f000a8b38e4',
                                                name: 'Mars Orange - M3R',
                                                defaultVariant: {
                                                    sku: 'J2W5ZGZ7Z D079-M3R',
                                                    priceVariants: null,
                                                    images: null,
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'paintDescription',
                                                        content: {
                                                            text: 'Mars Orange',
                                                        },
                                                    },
                                                    {
                                                        id: 'lacquerDescription',
                                                        content: {
                                                            text: 'Pearl/Metall',
                                                        },
                                                    },
                                                    {
                                                        id: 'paintCode',
                                                        content: {
                                                            text: 'M3R',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2c2330a3f000a8b3893',
                                                    name: 'Kia',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'varnishImages',
                                    content: null,
                                },
                                {
                                    id: 'isVarnishRecommended',
                                    content: {
                                        value: false,
                                    },
                                },
                                {
                                    id: 'varnishVatCode',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceIncludingVat',
                                    content: {
                                        number: 6490,
                                    },
                                },
                                {
                                    id: 'varnishPriceExcludingVat',
                                    content: {
                                        number: 6490,
                                    },
                                },
                                {
                                    id: 'varnishRetailPrice',
                                    content: {
                                        number: 5581,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginAmount',
                                    content: {
                                        number: 909,
                                    },
                                },
                                {
                                    id: 'varnishStandardPriceIncludingVat',
                                    content: {
                                        number: 6490,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginPercentage',
                                    content: {
                                        number: 14,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'varnish',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2c8671b020008b11372',
                                                name: 'Space Cadet Green - CEJ',
                                                defaultVariant: {
                                                    sku: 'J2W5ZGZ7Z D079-CEJ',
                                                    priceVariants: null,
                                                    images: null,
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'paintDescription',
                                                        content: {
                                                            text: 'Space Cadet Green',
                                                        },
                                                    },
                                                    {
                                                        id: 'lacquerDescription',
                                                        content: {
                                                            text: 'Standard',
                                                        },
                                                    },
                                                    {
                                                        id: 'paintCode',
                                                        content: {
                                                            text: 'CEJ',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2c2330a3f000a8b3893',
                                                    name: 'Kia',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'varnishImages',
                                    content: null,
                                },
                                {
                                    id: 'isVarnishRecommended',
                                    content: {
                                        value: true,
                                    },
                                },
                                {
                                    id: 'varnishVatCode',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceIncludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceExcludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishRetailPrice',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginAmount',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishStandardPriceIncludingVat',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginPercentage',
                                    content: {
                                        number: 0,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'varnish',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2c83419880008366aec',
                                                name: 'Neptune Blue - Cherry Black - SE2',
                                                defaultVariant: {
                                                    sku: 'J2W5ZGZ7Z D079-SE2',
                                                    priceVariants: null,
                                                    images: null,
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'paintDescription',
                                                        content: {
                                                            text: 'Neptune Blue - Cherry Black',
                                                        },
                                                    },
                                                    {
                                                        id: 'lacquerDescription',
                                                        content: {
                                                            text: 'Metall/Pearl',
                                                        },
                                                    },
                                                    {
                                                        id: 'paintCode',
                                                        content: {
                                                            text: 'SE2',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2c2330a3f000a8b3893',
                                                    name: 'Kia',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'varnishImages',
                                    content: null,
                                },
                                {
                                    id: 'isVarnishRecommended',
                                    content: {
                                        value: false,
                                    },
                                },
                                {
                                    id: 'varnishVatCode',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceIncludingVat',
                                    content: {
                                        number: 7490,
                                    },
                                },
                                {
                                    id: 'varnishPriceExcludingVat',
                                    content: {
                                        number: 7490,
                                    },
                                },
                                {
                                    id: 'varnishRetailPrice',
                                    content: {
                                        number: 6441,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginAmount',
                                    content: {
                                        number: 1049,
                                    },
                                },
                                {
                                    id: 'varnishStandardPriceIncludingVat',
                                    content: {
                                        number: 7490,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginPercentage',
                                    content: {
                                        number: 14,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'varnish',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2c83419880008366af8',
                                                name: 'Gravity Gray - KDG',
                                                defaultVariant: {
                                                    sku: 'J2W5ZGZ7Z D079-KDG',
                                                    priceVariants: null,
                                                    images: null,
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'paintDescription',
                                                        content: {
                                                            text: 'Gravity Gray',
                                                        },
                                                    },
                                                    {
                                                        id: 'lacquerDescription',
                                                        content: {
                                                            text: 'Pearl/Metall',
                                                        },
                                                    },
                                                    {
                                                        id: 'paintCode',
                                                        content: {
                                                            text: 'KDG',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2c2330a3f000a8b3893',
                                                    name: 'Kia',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'varnishImages',
                                    content: null,
                                },
                                {
                                    id: 'isVarnishRecommended',
                                    content: {
                                        value: false,
                                    },
                                },
                                {
                                    id: 'varnishVatCode',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceIncludingVat',
                                    content: {
                                        number: 6490,
                                    },
                                },
                                {
                                    id: 'varnishPriceExcludingVat',
                                    content: {
                                        number: 6490,
                                    },
                                },
                                {
                                    id: 'varnishRetailPrice',
                                    content: {
                                        number: 5581,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginAmount',
                                    content: {
                                        number: 909,
                                    },
                                },
                                {
                                    id: 'varnishStandardPriceIncludingVat',
                                    content: {
                                        number: 6490,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginPercentage',
                                    content: {
                                        number: 14,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'varnish',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2c83419880008366afc',
                                                name: 'Snow White Pearl - SWP',
                                                defaultVariant: {
                                                    sku: 'J2W5ZGZ7Z D079-SWP',
                                                    priceVariants: null,
                                                    images: null,
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'paintDescription',
                                                        content: {
                                                            text: 'Snow White Pearl',
                                                        },
                                                    },
                                                    {
                                                        id: 'lacquerDescription',
                                                        content: {
                                                            text: 'Pearl',
                                                        },
                                                    },
                                                    {
                                                        id: 'paintCode',
                                                        content: {
                                                            text: 'SWP',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2c2330a3f000a8b3893',
                                                    name: 'Kia',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'varnishImages',
                                    content: null,
                                },
                                {
                                    id: 'isVarnishRecommended',
                                    content: {
                                        value: false,
                                    },
                                },
                                {
                                    id: 'varnishVatCode',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceIncludingVat',
                                    content: {
                                        number: 6490,
                                    },
                                },
                                {
                                    id: 'varnishPriceExcludingVat',
                                    content: {
                                        number: 6490,
                                    },
                                },
                                {
                                    id: 'varnishRetailPrice',
                                    content: {
                                        number: 5581,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginAmount',
                                    content: {
                                        number: 909,
                                    },
                                },
                                {
                                    id: 'varnishStandardPriceIncludingVat',
                                    content: {
                                        number: 6490,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginPercentage',
                                    content: {
                                        number: 14,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'varnish',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2c83419880008366afe',
                                                name: 'Cherry Black - Inferno Red - AH5',
                                                defaultVariant: {
                                                    sku: 'J2W5ZGZ7Z D079-AH5',
                                                    priceVariants: null,
                                                    images: null,
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'paintDescription',
                                                        content: {
                                                            text: 'Cherry Black - Inferno Red',
                                                        },
                                                    },
                                                    {
                                                        id: 'lacquerDescription',
                                                        content: {
                                                            text: 'Pearl/Metall',
                                                        },
                                                    },
                                                    {
                                                        id: 'paintCode',
                                                        content: {
                                                            text: 'AH5',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2c2330a3f000a8b3893',
                                                    name: 'Kia',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'varnishImages',
                                    content: null,
                                },
                                {
                                    id: 'isVarnishRecommended',
                                    content: {
                                        value: false,
                                    },
                                },
                                {
                                    id: 'varnishVatCode',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceIncludingVat',
                                    content: {
                                        number: 7490,
                                    },
                                },
                                {
                                    id: 'varnishPriceExcludingVat',
                                    content: {
                                        number: 7490,
                                    },
                                },
                                {
                                    id: 'varnishRetailPrice',
                                    content: {
                                        number: 6441,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginAmount',
                                    content: {
                                        number: 1049,
                                    },
                                },
                                {
                                    id: 'varnishStandardPriceIncludingVat',
                                    content: {
                                        number: 7490,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginPercentage',
                                    content: {
                                        number: 14,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'varnish',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2c83419880008366b00',
                                                name: 'Sparkling Silver - KCS',
                                                defaultVariant: {
                                                    sku: 'J2W5ZGZ7Z D079-KCS',
                                                    priceVariants: null,
                                                    images: null,
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'paintDescription',
                                                        content: {
                                                            text: 'Sparkling Silver',
                                                        },
                                                    },
                                                    {
                                                        id: 'lacquerDescription',
                                                        content: {
                                                            text: 'Metall',
                                                        },
                                                    },
                                                    {
                                                        id: 'paintCode',
                                                        content: {
                                                            text: 'KCS',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2c2330a3f000a8b3893',
                                                    name: 'Kia',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'varnishImages',
                                    content: null,
                                },
                                {
                                    id: 'isVarnishRecommended',
                                    content: {
                                        value: false,
                                    },
                                },
                                {
                                    id: 'varnishVatCode',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'varnishPriceIncludingVat',
                                    content: {
                                        number: 6490,
                                    },
                                },
                                {
                                    id: 'varnishPriceExcludingVat',
                                    content: {
                                        number: 6490,
                                    },
                                },
                                {
                                    id: 'varnishRetailPrice',
                                    content: {
                                        number: 5581,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginAmount',
                                    content: {
                                        number: 909,
                                    },
                                },
                                {
                                    id: 'varnishStandardPriceIncludingVat',
                                    content: {
                                        number: 6490,
                                    },
                                },
                                {
                                    id: 'varnishRetailMarginPercentage',
                                    content: {
                                        number: 14,
                                    },
                                },
                            ],
                        ],
                    },
                },
                {
                    id: 'accessories',
                    content: {
                        chunks: [
                            [
                                {
                                    id: 'accessory',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2e13419880008366ca0',
                                                name: 'Beskyttelsesfolie J2272ADE00TR',
                                                defaultVariant: {
                                                    sku: 'J2272ADE00TR',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/154/j2272ade00tr.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/154/j2272ade00tr.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/154/@100/j2272ade00tr.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/154/@100/j2272ade00tr.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/154/@100/j2272ade00tr.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/154/@100/j2272ade00tr.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/154/@100/j2272ade00tr.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/154/@100/j2272ade00tr.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/154/@200/j2272ade00tr.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/154/@200/j2272ade00tr.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/154/@200/j2272ade00tr.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/154/@200/j2272ade00tr.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/154/@200/j2272ade00tr.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/154/@200/j2272ade00tr.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/154/@500/j2272ade00tr.avif',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/154/@500/j2272ade00tr.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/154/@500/j2272ade00tr.webp',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/154/@500/j2272ade00tr.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/154/@500/j2272ade00tr.jpeg',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/154/@500/j2272ade00tr.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'Beskyttelsesfolie støtfanger bak - J2272ADE00TR',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleNumber',
                                                        content: {
                                                            text: 'J2272ADE00TR',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleName',
                                                        content: {
                                                            text: 'Beskyttelsesfolie',
                                                        },
                                                    },
                                                    {
                                                        id: 'brandSpecific',
                                                        content: {
                                                            value: true,
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2db671b020008b114c2',
                                                    name: 'Kia',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'accessoryTimeAssembly',
                                    content: {
                                        number: 0.2,
                                    },
                                },
                                {
                                    id: 'accessoryIndicativePriceExcludingVatAndAssembly',
                                    content: {
                                        number: 698,
                                    },
                                },
                                {
                                    id: 'accessoryAssemblyPriceExcludingVat',
                                    content: {
                                        number: 1350,
                                    },
                                },
                                {
                                    id: 'accessoryVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryVatEl',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatIce',
                                    content: {
                                        number: 1210,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatEl',
                                    content: {
                                        number: 970,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatIce',
                                    content: {
                                        number: 968,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatEl',
                                    content: {
                                        number: 970,
                                    },
                                },
                                {
                                    id: 'accessoryRetailPriceExcludingVat',
                                    content: {
                                        number: 593,
                                    },
                                },
                                {
                                    id: 'accessoryRetailerMargin',
                                    content: {
                                        number: 105,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'accessory',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2e1671b020008b11510',
                                                name: 'Bagasjeromsmatte J2120ADE00',
                                                defaultVariant: {
                                                    sku: 'J2120ADE00',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/131/j2120ade00.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/131/j2120ade00.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/131/@100/j2120ade00.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/131/@100/j2120ade00.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/131/@100/j2120ade00.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/131/@100/j2120ade00.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/131/@100/j2120ade00.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/131/@100/j2120ade00.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/131/@200/j2120ade00.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/131/@200/j2120ade00.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/131/@200/j2120ade00.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/131/@200/j2120ade00.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/131/@200/j2120ade00.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/131/@200/j2120ade00.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/131/@500/j2120ade00.avif',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/131/@500/j2120ade00.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/131/@500/j2120ade00.webp',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/131/@500/j2120ade00.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/131/@500/j2120ade00.jpeg',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/131/@500/j2120ade00.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/131/@768/j2120ade00.avif',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/131/@768/j2120ade00.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/131/@768/j2120ade00.webp',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/131/@768/j2120ade00.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/131/@768/j2120ade00.jpeg',
                                                                    width: 768,
                                                                    key: 'bos-no-ecom-2/21/4/26/131/@768/j2120ade00.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'Bagasjeromsmatte i velour - J2120ADE00',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleNumber',
                                                        content: {
                                                            text: 'J2120ADE00',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleName',
                                                        content: {
                                                            text: 'Bagasjeromsmatte',
                                                        },
                                                    },
                                                    {
                                                        id: 'brandSpecific',
                                                        content: {
                                                            value: true,
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2db671b020008b114c2',
                                                    name: 'Kia',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'accessoryTimeAssembly',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryIndicativePriceExcludingVatAndAssembly',
                                    content: {
                                        number: 1041,
                                    },
                                },
                                {
                                    id: 'accessoryAssemblyPriceExcludingVat',
                                    content: {
                                        number: 1350,
                                    },
                                },
                                {
                                    id: 'accessoryVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryVatEl',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatIce',
                                    content: {
                                        number: 1310,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatEl',
                                    content: {
                                        number: 1050,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatIce',
                                    content: {
                                        number: 1048,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatEl',
                                    content: {
                                        number: 1050,
                                    },
                                },
                                {
                                    id: 'accessoryRetailPriceExcludingVat',
                                    content: {
                                        number: 885,
                                    },
                                },
                                {
                                    id: 'accessoryRetailerMargin',
                                    content: {
                                        number: 156,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'accessory',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2e0671b020008b1150a',
                                                name: 'Sykkelholder E823055001',
                                                defaultVariant: {
                                                    sku: 'E823055001',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/124/e823055001.png',
                                                            key: 'bos-no-ecom-2/21/4/26/124/e823055001.png',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/124/@100/e823055001.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/124/@100/e823055001.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/124/@100/e823055001.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/124/@100/e823055001.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/124/@100/e823055001.png',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/124/@100/e823055001.png',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/124/@200/e823055001.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/124/@200/e823055001.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/124/@200/e823055001.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/124/@200/e823055001.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/124/@200/e823055001.png',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/124/@200/e823055001.png',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/124/@500/e823055001.avif',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/124/@500/e823055001.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/124/@500/e823055001.webp',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/124/@500/e823055001.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/124/@500/e823055001.png',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/124/@500/e823055001.png',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'Sykkelholder for hengerfeste - E823055001',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleNumber',
                                                        content: {
                                                            text: 'E823055001',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleName',
                                                        content: {
                                                            text: 'Sykkelholder',
                                                        },
                                                    },
                                                    {
                                                        id: 'brandSpecific',
                                                        content: {
                                                            value: true,
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2db671b020008b114c2',
                                                    name: 'Kia',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'accessoryTimeAssembly',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryIndicativePriceExcludingVatAndAssembly',
                                    content: {
                                        number: 6018,
                                    },
                                },
                                {
                                    id: 'accessoryAssemblyPriceExcludingVat',
                                    content: {
                                        number: 1350,
                                    },
                                },
                                {
                                    id: 'accessoryVatIce',
                                    content: {
                                        number: 325,
                                    },
                                },
                                {
                                    id: 'accessoryVatEl',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatIce',
                                    content: {
                                        number: 25580,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatEl',
                                    content: {
                                        number: 7530,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatIce',
                                    content: {
                                        number: 6019,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatEl',
                                    content: {
                                        number: 6024,
                                    },
                                },
                                {
                                    id: 'accessoryRetailPriceExcludingVat',
                                    content: {
                                        number: 5115,
                                    },
                                },
                                {
                                    id: 'accessoryRetailerMargin',
                                    content: {
                                        number: 903,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'accessory',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2e1330a3f000a8b3a79',
                                                name: 'Gulvmatter J2143ADE00',
                                                defaultVariant: {
                                                    sku: 'J2143ADE00',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/95/j2143ade00.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/95/j2143ade00.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/95/@100/j2143ade00.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/95/@100/j2143ade00.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/95/@100/j2143ade00.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/95/@100/j2143ade00.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/95/@100/j2143ade00.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/95/@100/j2143ade00.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/95/@200/j2143ade00.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/95/@200/j2143ade00.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/95/@200/j2143ade00.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/95/@200/j2143ade00.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/95/@200/j2143ade00.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/95/@200/j2143ade00.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/95/@500/j2143ade00.avif',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/95/@500/j2143ade00.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/95/@500/j2143ade00.webp',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/95/@500/j2143ade00.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/95/@500/j2143ade00.jpeg',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/95/@500/j2143ade00.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'Gulvmatter i velour - J2143ADE00',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleNumber',
                                                        content: {
                                                            text: 'J2143ADE00',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleName',
                                                        content: {
                                                            text: 'Gulvmatter',
                                                        },
                                                    },
                                                    {
                                                        id: 'brandSpecific',
                                                        content: {
                                                            value: true,
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2db671b020008b114c2',
                                                    name: 'Kia',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'accessoryTimeAssembly',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryIndicativePriceExcludingVatAndAssembly',
                                    content: {
                                        number: 1054,
                                    },
                                },
                                {
                                    id: 'accessoryAssemblyPriceExcludingVat',
                                    content: {
                                        number: 1350,
                                    },
                                },
                                {
                                    id: 'accessoryVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryVatEl',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatIce',
                                    content: {
                                        number: 1320,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatEl',
                                    content: {
                                        number: 1060,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatIce',
                                    content: {
                                        number: 1056,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatEl',
                                    content: {
                                        number: 1060,
                                    },
                                },
                                {
                                    id: 'accessoryRetailPriceExcludingVat',
                                    content: {
                                        number: 896,
                                    },
                                },
                                {
                                    id: 'accessoryRetailerMargin',
                                    content: {
                                        number: 158,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'accessory',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2e1330a3f000a8b3a86',
                                                name: 'Lastestativ J2211ADE10AL',
                                                defaultVariant: {
                                                    sku: 'J2211ADE10AL',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/102/j2211ade10al.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/102/j2211ade10al.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/102/@100/j2211ade10al.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/102/@100/j2211ade10al.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/102/@100/j2211ade10al.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/102/@100/j2211ade10al.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/102/@100/j2211ade10al.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/102/@100/j2211ade10al.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/102/@200/j2211ade10al.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/102/@200/j2211ade10al.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/102/@200/j2211ade10al.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/102/@200/j2211ade10al.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/102/@200/j2211ade10al.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/102/@200/j2211ade10al.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/102/@500/j2211ade10al.avif',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/102/@500/j2211ade10al.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/102/@500/j2211ade10al.webp',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/102/@500/j2211ade10al.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/102/@500/j2211ade10al.jpeg',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/102/@500/j2211ade10al.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: 'Lastestativ aluminium - J2211ADE10AL',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleNumber',
                                                        content: {
                                                            text: 'J2211ADE10AL',
                                                        },
                                                    },
                                                    {
                                                        id: 'articleName',
                                                        content: {
                                                            text: 'Lastestativ',
                                                        },
                                                    },
                                                    {
                                                        id: 'brandSpecific',
                                                        content: {
                                                            value: true,
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2db671b020008b114c2',
                                                    name: 'Kia',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'accessoryTimeAssembly',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'accessoryIndicativePriceExcludingVatAndAssembly',
                                    content: {
                                        number: 1825,
                                    },
                                },
                                {
                                    id: 'accessoryAssemblyPriceExcludingVat',
                                    content: {
                                        number: 1350,
                                    },
                                },
                                {
                                    id: 'accessoryVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryVatEl',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatIce',
                                    content: {
                                        number: 2290,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceIncludingVatEl',
                                    content: {
                                        number: 2290,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatIce',
                                    content: {
                                        number: 1832,
                                    },
                                },
                                {
                                    id: 'accessoryCustomerPriceExcludingVatEl',
                                    content: {
                                        number: 1832,
                                    },
                                },
                                {
                                    id: 'accessoryRetailPriceExcludingVat',
                                    content: {
                                        number: 1551,
                                    },
                                },
                                {
                                    id: 'accessoryRetailerMargin',
                                    content: {
                                        number: 274,
                                    },
                                },
                            ],
                        ],
                    },
                },
                {
                    id: 'wheels',
                    content: {
                        chunks: [
                            [
                                {
                                    id: 'wheelSet',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2da3419880008366c48',
                                                name: 'NOWA03780/NOWA03780',
                                                defaultVariant: {
                                                    sku: 'NOWA03780/NOWA03780',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/162/nowa03780.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/162/nowa03780.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/162/@100/nowa03780.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/162/@100/nowa03780.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/162/@100/nowa03780.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/162/@100/nowa03780.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/162/@100/nowa03780.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/162/@100/nowa03780.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/162/@200/nowa03780.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/162/@200/nowa03780.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/162/@200/nowa03780.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/162/@200/nowa03780.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/162/@200/nowa03780.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/162/@200/nowa03780.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'tireManufacturer',
                                                        content: {
                                                            text: 'Nokian',
                                                        },
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: '17" sølvfargede felger med TPMS',
                                                        },
                                                    },
                                                    {
                                                        id: 'nowaCodes',
                                                        content: {
                                                            chunks: [
                                                                [
                                                                    {
                                                                        id: 'code',
                                                                        content: {
                                                                            text: 'NOWA03780/NOWA03780',
                                                                        },
                                                                    },
                                                                    {
                                                                        id: 'front',
                                                                        content: {
                                                                            text: 'NOWA03780',
                                                                        },
                                                                    },
                                                                    {
                                                                        id: 'rear',
                                                                        content: {
                                                                            text: 'NOWA03780',
                                                                        },
                                                                    },
                                                                ],
                                                            ],
                                                        },
                                                    },
                                                    {
                                                        id: 'tireType',
                                                        content: {
                                                            text: 'Pigg',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2d83419880008366c20',
                                                    name: 'Kia',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'isWheelSetRecommended',
                                    content: {
                                        value: false,
                                    },
                                },
                                {
                                    id: 'wheelSetVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'wheelSetVatEl',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceBeforeVat',
                                    content: {
                                        number: 20800,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceIncludingVatIce',
                                    content: {
                                        number: 26000,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceIncludingVatEl',
                                    content: {
                                        number: 20800,
                                    },
                                },
                                {
                                    id: 'wheelSetRetailerPriceExcludingVat',
                                    content: {
                                        number: 17680,
                                    },
                                },
                                {
                                    id: 'wheelSetRetailerMargin',
                                    content: {
                                        number: 3120,
                                    },
                                },
                                {
                                    id: 'wheelSetIndicativeSalesPriceExcludingVat',
                                    content: {
                                        number: 20732,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'wheelSet',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2da3419880008366c46',
                                                name: 'NOWA03783/NOWA03783',
                                                defaultVariant: {
                                                    sku: 'NOWA03783/NOWA03783',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/167/nowa03783.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/167/nowa03783.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/167/@100/nowa03783.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/167/@100/nowa03783.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/167/@100/nowa03783.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/167/@100/nowa03783.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/167/@100/nowa03783.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/167/@100/nowa03783.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/167/@200/nowa03783.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/167/@200/nowa03783.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/167/@200/nowa03783.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/167/@200/nowa03783.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/167/@200/nowa03783.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/167/@200/nowa03783.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/167/@500/nowa03783.avif',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/167/@500/nowa03783.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/167/@500/nowa03783.webp',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/167/@500/nowa03783.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/167/@500/nowa03783.jpeg',
                                                                    width: 500,
                                                                    key: 'bos-no-ecom-2/21/4/26/167/@500/nowa03783.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'tireManufacturer',
                                                        content: {
                                                            text: 'Nokian',
                                                        },
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: '17" sorte felger med TPMS',
                                                        },
                                                    },
                                                    {
                                                        id: 'nowaCodes',
                                                        content: {
                                                            chunks: [
                                                                [
                                                                    {
                                                                        id: 'code',
                                                                        content: {
                                                                            text: 'NOWA03783/NOWA03783',
                                                                        },
                                                                    },
                                                                    {
                                                                        id: 'front',
                                                                        content: {
                                                                            text: 'NOWA03783',
                                                                        },
                                                                    },
                                                                    {
                                                                        id: 'rear',
                                                                        content: {
                                                                            text: 'NOWA03783',
                                                                        },
                                                                    },
                                                                ],
                                                            ],
                                                        },
                                                    },
                                                    {
                                                        id: 'tireType',
                                                        content: {
                                                            text: 'Piggfri',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2d83419880008366c20',
                                                    name: 'Kia',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'isWheelSetRecommended',
                                    content: {
                                        value: false,
                                    },
                                },
                                {
                                    id: 'wheelSetVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'wheelSetVatEl',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceBeforeVat',
                                    content: {
                                        number: 20400,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceIncludingVatIce',
                                    content: {
                                        number: 25500,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceIncludingVatEl',
                                    content: {
                                        number: 20400,
                                    },
                                },
                                {
                                    id: 'wheelSetRetailerPriceExcludingVat',
                                    content: {
                                        number: 17340,
                                    },
                                },
                                {
                                    id: 'wheelSetRetailerMargin',
                                    content: {
                                        number: 3060,
                                    },
                                },
                                {
                                    id: 'wheelSetIndicativeSalesPriceExcludingVat',
                                    content: {
                                        number: 20377,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'wheelSet',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2db330a3f000a8b3a32',
                                                name: 'NOWA03781/NOWA03781',
                                                defaultVariant: {
                                                    sku: 'NOWA03781/NOWA03781',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/166/nowa03781.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/166/nowa03781.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/166/@100/nowa03781.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/166/@100/nowa03781.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/166/@100/nowa03781.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/166/@100/nowa03781.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/166/@100/nowa03781.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/166/@100/nowa03781.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/166/@200/nowa03781.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/166/@200/nowa03781.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/166/@200/nowa03781.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/166/@200/nowa03781.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/166/@200/nowa03781.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/166/@200/nowa03781.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'tireManufacturer',
                                                        content: {
                                                            text: 'Nokian',
                                                        },
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: '17" sølvfargede felger med TPMS',
                                                        },
                                                    },
                                                    {
                                                        id: 'nowaCodes',
                                                        content: {
                                                            chunks: [
                                                                [
                                                                    {
                                                                        id: 'code',
                                                                        content: {
                                                                            text: 'NOWA03781/NOWA03781',
                                                                        },
                                                                    },
                                                                    {
                                                                        id: 'front',
                                                                        content: {
                                                                            text: 'NOWA03781',
                                                                        },
                                                                    },
                                                                    {
                                                                        id: 'rear',
                                                                        content: {
                                                                            text: 'NOWA03781',
                                                                        },
                                                                    },
                                                                ],
                                                            ],
                                                        },
                                                    },
                                                    {
                                                        id: 'tireType',
                                                        content: {
                                                            text: 'Piggfri',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2d83419880008366c20',
                                                    name: 'Kia',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'isWheelSetRecommended',
                                    content: {
                                        value: true,
                                    },
                                },
                                {
                                    id: 'wheelSetVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'wheelSetVatEl',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceBeforeVat',
                                    content: {
                                        number: 20400,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceIncludingVatIce',
                                    content: {
                                        number: 25500,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceIncludingVatEl',
                                    content: {
                                        number: 20400,
                                    },
                                },
                                {
                                    id: 'wheelSetRetailerPriceExcludingVat',
                                    content: {
                                        number: 17340,
                                    },
                                },
                                {
                                    id: 'wheelSetRetailerMargin',
                                    content: {
                                        number: 3060,
                                    },
                                },
                                {
                                    id: 'wheelSetIndicativeSalesPriceExcludingVat',
                                    content: {
                                        number: 20377,
                                    },
                                },
                            ],
                            [
                                {
                                    id: 'wheelSet',
                                    content: {
                                        items: [
                                            {
                                                id: '608fe2db330a3f000a8b3a35',
                                                name: 'NOWA03785/NOWA03785',
                                                defaultVariant: {
                                                    sku: 'NOWA03785/NOWA03785',
                                                    priceVariants: null,
                                                    images: [
                                                        {
                                                            url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/163/nowa03785.jpg',
                                                            key: 'bos-no-ecom-2/21/4/26/163/nowa03785.jpg',
                                                            variants: [
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/163/@100/nowa03785.avif',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/163/@100/nowa03785.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/163/@100/nowa03785.webp',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/163/@100/nowa03785.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/163/@100/nowa03785.jpeg',
                                                                    width: 100,
                                                                    key: 'bos-no-ecom-2/21/4/26/163/@100/nowa03785.jpeg',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/163/@200/nowa03785.avif',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/163/@200/nowa03785.avif',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/163/@200/nowa03785.webp',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/163/@200/nowa03785.webp',
                                                                },
                                                                {
                                                                    url: 'https://media.crystallize.com/bos-no-ecom-2/21/4/26/163/@200/nowa03785.jpeg',
                                                                    width: 200,
                                                                    key: 'bos-no-ecom-2/21/4/26/163/@200/nowa03785.jpeg',
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                components: [
                                                    {
                                                        id: 'images',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'manufacturer',
                                                        content: null,
                                                    },
                                                    {
                                                        id: 'tireManufacturer',
                                                        content: {
                                                            text: 'Nokian',
                                                        },
                                                    },
                                                    {
                                                        id: 'description',
                                                        content: {
                                                            text: '17" bicolour felger med TPMS',
                                                        },
                                                    },
                                                    {
                                                        id: 'nowaCodes',
                                                        content: {
                                                            chunks: [
                                                                [
                                                                    {
                                                                        id: 'code',
                                                                        content: {
                                                                            text: 'NOWA03785/NOWA03785',
                                                                        },
                                                                    },
                                                                    {
                                                                        id: 'front',
                                                                        content: {
                                                                            text: 'NOWA03785',
                                                                        },
                                                                    },
                                                                    {
                                                                        id: 'rear',
                                                                        content: {
                                                                            text: 'NOWA03785',
                                                                        },
                                                                    },
                                                                ],
                                                            ],
                                                        },
                                                    },
                                                    {
                                                        id: 'tireType',
                                                        content: {
                                                            text: 'Piggfri',
                                                        },
                                                    },
                                                ],
                                                manufacturer: {
                                                    id: '608fe2d83419880008366c20',
                                                    name: 'Kia',
                                                    components: [
                                                        {
                                                            id: 'logo',
                                                            content: null,
                                                        },
                                                        {
                                                            id: 'description',
                                                            content: null,
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    id: 'isWheelSetRecommended',
                                    content: {
                                        value: false,
                                    },
                                },
                                {
                                    id: 'wheelSetVatIce',
                                    content: {
                                        number: 25,
                                    },
                                },
                                {
                                    id: 'wheelSetVatEl',
                                    content: {
                                        number: 0,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceBeforeVat',
                                    content: {
                                        number: 21000,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceIncludingVatIce',
                                    content: {
                                        number: 26250,
                                    },
                                },
                                {
                                    id: 'wheelSetPriceIncludingVatEl',
                                    content: {
                                        number: 21000,
                                    },
                                },
                                {
                                    id: 'wheelSetRetailerPriceExcludingVat',
                                    content: {
                                        number: 17850,
                                    },
                                },
                                {
                                    id: 'wheelSetRetailerMargin',
                                    content: {
                                        number: 3150,
                                    },
                                },
                                {
                                    id: 'wheelSetIndicativeSalesPriceExcludingVat',
                                    content: {
                                        number: 20987,
                                    },
                                },
                            ],
                        ],
                    },
                },
                {
                    id: 'interiors',
                    content: null,
                },
            ],
            model: {
                id: '608fe2c2671b020008b11311',
                name: 'e-Soul',
                components: [
                    {
                        id: 'manufacturer',
                        content: null,
                    },
                    {
                        id: 'marketing',
                        content: null,
                    },
                    {
                        id: 'availableOnBos',
                        content: {
                            value: false,
                        },
                    },
                    {
                        id: 'availableOnNext',
                        content: {
                            value: true,
                        },
                    },
                    {
                        id: 'quoteText',
                        content: {
                            plainText: [''],
                        },
                    },
                    {
                        id: 'campaignText',
                        content: null,
                    },
                    {
                        id: 'carType',
                        content: {
                            text: 'EL',
                        },
                    },
                    {
                        id: 'allRelatedTrim',
                        content: null,
                    },
                    {
                        id: 'sellableTrimsOnBos',
                        content: null,
                    },
                    {
                        id: 'productCardFeaturedTrim',
                        content: null,
                    },
                    {
                        id: 'properties',
                        content: {
                            sections: [
                                {
                                    title: 'Car',
                                    properties: [
                                        {
                                            key: 'bodyType',
                                            value: 'Kombi',
                                        },
                                        {
                                            key: 'luggageVolume',
                                            value: '315',
                                        },
                                        {
                                            key: 'numberOfSeats',
                                            value: '5',
                                        },
                                        {
                                            key: 'modelYear',
                                            value: '2021',
                                        },
                                        {
                                            key: 'towingCapacity',
                                            value: '0',
                                        },
                                        {
                                            key: 'roofCapacity',
                                            value: '100 kg',
                                        },
                                    ],
                                },
                                {
                                    title: 'Motor',
                                    properties: [
                                        {
                                            key: 'fuel',
                                            value: 'Elektrisk',
                                        },
                                        {
                                            key: 'powertrain',
                                            value: 'Forhjulsdrift',
                                        },
                                        {
                                            key: 'transmission',
                                            value: 'Automat',
                                        },
                                        {
                                            key: 'consumption',
                                            value: '156 Wh/km',
                                        },
                                        {
                                            key: 'effect',
                                            value: '136 hk',
                                        },
                                    ],
                                },
                                {
                                    title: 'Electric',
                                    properties: [
                                        {
                                            key: 'electricRange',
                                            value: '276 km',
                                        },
                                        {
                                            key: 'batteryCapacity',
                                            value: '39 kWh',
                                        },
                                        {
                                            key: 'chargingCapacityAC',
                                            value: '7,2 kW',
                                        },
                                        {
                                            key: 'chargingCapacityDC',
                                            value: '40 kW',
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                ],
                modelSeries: {
                    id: '60cc62095e0940000944f5b7',
                    name: 'e-Soul 39,2kW',
                    components: [],
                    manufacturer: {
                        id: '608fe2c1671b020008b11309',
                        name: 'Kia',
                        components: [
                            {
                                id: 'logo',
                                content: null,
                            },
                            {
                                id: 'description',
                                content: null,
                            },
                        ],
                    },
                },
            },
        },
        hierarchy: {
            manufacturers: [
                {
                    name: 'Mercedes-Benz',
                    series: [
                        {
                            name: 'EQC',
                            models: [
                                {
                                    name: 'EQC 400 4M',
                                    salesPackages: [
                                        {
                                            name: 'EQC400 AMG Edition Premium Plus',
                                            topics: [
                                                {
                                                    name: '10klikk',
                                                    path: '/kanal/10klikk',
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            name: 'EQA',
                            models: [
                                {
                                    name: 'EQA 250',
                                    salesPackages: [
                                        {
                                            name: 'EQA 250 Progressive',
                                            topics: [
                                                {
                                                    name: '10klikk',
                                                    path: '/kanal/10klikk',
                                                },
                                            ],
                                        },
                                    ],
                                },
                                { name: 'EQA 300 4M' },
                                { name: 'EQA 350 4M' },
                            ],
                        },
                        {
                            name: 'A-Klasse',
                            models: [{ name: 'A 250 e' }],
                        },
                        {
                            name: 'B-Klasse',
                            models: [{ name: 'B 250 e' }],
                        },
                        {
                            name: 'E-Klasse',
                            models: [
                                { name: 'E 300 e' },
                                { name: 'E 300 de' },
                                { name: 'E 220 d 4M' },
                                { name: 'E 200 4M' },
                                { name: 'E 450 4M' },
                                { name: 'E 400 d 4M' },
                                { name: 'E 300 de 4M T' },
                                { name: 'E 220 d 4M T' },
                                { name: 'E 220 d 4M All-Terrain' },
                            ],
                        },
                    ],
                },
                {
                    name: 'Peugeot',
                    series: [
                        {
                            name: '208',
                            models: [
                                { name: '208 75hk' },
                                { name: '208 100hk' },
                                { name: '208 130hk' },
                                {
                                    name: 'e208',
                                    salesPackages: [
                                        {
                                            name: 'Allure',
                                            topics: [
                                                {
                                                    name: '10klikk',
                                                    path: '/kanal/10klikk',
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            name: '508',
                            models: [
                                { name: '508 PSE PHEV 4x4' },
                                { name: '508 SW PSE PHEV 4x4' },
                                { name: '508 PHEV' },
                                { name: '508 SW PHEV' },
                                { name: '508 SW' },
                            ],
                        },
                        {
                            name: '2008',
                            models: [
                                { name: '2008 1.2' },
                                { name: '2008 1.5' },
                                { name: '2008 1.2' },
                                { name: '2008 1.5' },
                                {
                                    name: 'e2008',
                                    salesPackages: [
                                        {
                                            name: 'GT',
                                            topics: [
                                                {
                                                    name: '10klikk',
                                                    path: '/kanal/10klikk',
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
                {
                    name: 'Kia',
                    series: [
                        {
                            name: 'e-Soul',
                            models: [{ name: 'e-Soul 64kW, 7.2kW' }, { name: 'e-Soul 64kW, 11kW' }, { name: 'e-Soul 39,2kW' }],
                        },
                        {
                            name: 'e-Niro',
                            models: [
                                { name: 'e-Niro, 7.2kW' },
                                {
                                    name: 'e-Niro, 11kW',
                                    salesPackages: [
                                        {
                                            name: 'Active',
                                            topics: [
                                                {
                                                    name: '10klikk',
                                                    path: '/kanal/10klikk',
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            name: 'Sorento',
                            models: [
                                { name: 'Sorento 1.6 T-GDI' },
                                { name: 'Sorento 1.6 T-GDI' },
                                { name: 'Sorento 1.6 T-GDI' },
                                { name: 'Sorento 1.6 T-GDI' },
                                { name: 'Sorento 2.2 CRDi' },
                                { name: 'Sorento 2.2 CRDi' },
                            ],
                        },
                        {
                            name: 'Stonic',
                            models: [{ name: 'Stonic' }],
                        },
                        {
                            name: 'Niro',
                            models: [{ name: 'Niro Hybrid' }, { name: 'Niro Plug-in hybrid' }],
                        },
                    ],
                },
            ],
        },
    },
};
//# sourceMappingURL=vehicle-catalogue.js.map